var mobile = false;

window.addEventListener("load", (event) =>{
    const data_page = document.querySelector("[data-page]");
    if(typeof data_page === "undefined" || data_page === null || !data_page.dataset.page.includes("{")){ 
      return; 
    }
    const pageSettings = JSON.parse(data_page.dataset.page);
    const animationController = new ScrollMagic.Controller({ addIndicators: false }); //pageSettings.markers
    only_ios();
    pinSections(animationController,["Duxbackpack", "duxShell", "myth18L", "duxPlus", "Chargetreemag"], pageSettings.page);
    ARSection(animationController);
    
    switch (pageSettings.page) {
      case "chargetreeAir":
        chargeTreeAir(animationController);
        break;
        case "duxUltra":
        duxUltra(animationController);
        break;
      case "duxling":
        duxling(animationController);
        break;  
      case "duxling_V2":
        duxling_v2(animationController);
        break;
      case "smarter":
        smarter();
        break;
      case "education":
        education(animationController);
        break;
      case "corporate":
        corporate(animationController);
        break;
      case "focus_roll":
        focus_roll(animationController);
        break;
      case "dux_swivel":
        dux_swivel(animationController);
        break;
      case "Chargetreemag":
        chargeTreeMag(animationController);
        break;
      case "Backpack2023":
        backPack2023(animationController);
        break;
      case "reawaken":
        reawaken(animationController);
        break;
      case "relax":
        relax(animationController);
        break;
      case "reveal":
        reveal(animationController);
        break;
      case "DuxBackpack16":
        dux_backpack_16l(animationController);
        break;
      case "duxStudio":
        duxStudio(animationController);
        break;
      case "duxPlus":
        duxPlus(animationController);
        break;
      case "Duxbackpack":
        DuxBackpack30l(animationController);
        break;
      case "duxShell":
        duxShell(animationController);
        break;
      case "myth18L":
        myth18L(animationController);
        break;
      case "duxPlusDuo":
        duxPlusDuo(animationController);
        break;
      case "duxKeyboard":
        duxKeyboard(animationController);
        break;
    }

    jQuery( '.display-mobile .btnColores span' ).on( 'click', function() {
        var buttonClassString = jQuery( this ).attr( 'class' ), buttonColorClassName, buttonColor, labelContainer;
        if( buttonClassString && ( buttonColorClassName = buttonClassString.match( /\bbtnColor([A-Za-z]+)/ ) ) ) {
            buttonColor = buttonColorClassName[1];
            jQuery( this ).closest( '.display-mobile' ).find( 'p' ).html( buttonColor );
        }
    });
});

window.addEventListener('resize', (event) => {
    // location.reload();
});

function isMobile(){
    const m = window.matchMedia( '(max-width: 767px)' ).matches;
    return m;
}

function only_ios(){
    if(!ios()){
        gsap.utils.toArray(".only_ios").forEach(function(section){ section.style="display: none;" });
    }
}

function ios() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function setAnimation(sceneOptions, tween, controller, indicatorOptions) {
    new ScrollMagic.Scene(sceneOptions).setTween(tween).addTo(controller);
}

function pinSections(controller, exceptions, page) {
  if(exceptions.includes(page) && isMobile2() || exceptions.includes(page) && (navigator.userAgent.includes("Mac") && "ontouchend" in document)){return}
  
    if(isMobile){
      gsap.utils.toArray(".PinSection-mobile").forEach(
          function (section) {
              new ScrollMagic.Scene({triggerElement: section, triggerHook: 0, duration: "100%"}).setPin(section).addTo(controller);
          });
    }
    gsap.utils.toArray(".PinSection").forEach(
        function (section) {
            new ScrollMagic.Scene({triggerElement: section, triggerHook: 0, duration: "100%"}).setPin(section).addTo(controller);
        });
}

function ARSection(controller) {
    const sceneOptions = { triggerElement: "#AR", duration: "30%" };

    const tween_phone = TweenMax.fromTo("#AR_phone", 1, { bottom: -500, opacity: 0 }, { bottom: 0, opacity: 1, ease: Linear.easeNone });
    const indicatorOptions_phone = { name: "Phone AR" };
    setAnimation(sceneOptions, tween_phone, controller, indicatorOptions_phone);

    const tween_product = TweenMax.fromTo("#AR_obj", 1, { bottom: -500, scale: 0, opacity: 0 }, { bottom: 0, scale: 1, opacity: 1, ease: Linear.easeNone });
    const indicatorOptions_product = { name: "Product AR" };
    setAnimation(sceneOptions, tween_product, controller, indicatorOptions_product);
}

function duxling(controller){
    // SMARTER FEATURES
    const SceneOptions_smarter = {triggerElement: "#smarter_section", duration: "100%", triggerHook: 0};
    const smarter_tween = new TimelineMax()
    .fromTo("#case_smarter", 1, { left: 500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#bubbles_1", 1, { top: 50, opacity: 0}, { top:0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#bubbles_2", 1, { top:-50, opacity: 0}, { top:0, opacity: 1, ease: Linear.easeNone });
    const smarter_indicator = { name: "smarter" };
    setAnimation(SceneOptions_smarter, smarter_tween, controller, smarter_indicator);
  
    // INNOVATIVE
    const sceneOptions_inovative_options = { triggerElement: "#inovative", triggerHook: 0, duration: "100%" };
    let imagesRotating = [
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_Duxling_03_00000.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00002.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00004.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00006.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00008.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00010.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00012.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00014.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00016.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00018.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00020.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00022.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00023.png?v=1729892516",

    ];
    let objectRotating = { curImg: 0 };
    const tween_inovative_options = TweenMax.to(objectRotating, 0.5, {
        curImg: imagesRotating.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("inovative_img").src = imagesRotating[objectRotating.curImg];
        }
    });
    const indicatorOptions_inovative_options = { name: "rotatingImg" };
    setAnimation(sceneOptions_inovative_options, tween_inovative_options, controller, indicatorOptions_inovative_options)
  
    const sceneOptions_VIEWING_options = { triggerElement: "#viewing", triggerHook: 0, duration: "100%" };
    let imagesVIEWING = [
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00000.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00001.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00002.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00003.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00004.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00005.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00006.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00007.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00008.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00009.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00010.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00011.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00012.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00013.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00014.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00015.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00016.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00017.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00018.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00019.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00020.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00021.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00022.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00023.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00024.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00025.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00026.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00027.png?v=1729893661",

    ];
    let objectVIEWING = { curImg: 0 };
    const tween_VIEWING_options = TweenMax.to(objectVIEWING, 0.5, {
        curImg: imagesVIEWING.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("VIEWING_img").srcset = imagesVIEWING[objectVIEWING.curImg];
        }
    });
    const indicatorOptions_VIEWING_options = { name: "rotatingImg" };
    setAnimation(sceneOptions_VIEWING_options, tween_VIEWING_options, controller, indicatorOptions_VIEWING_options);

    // HIGH-PERFORMING
    let caseLeft = "5em";
    if(isMobile()){
        caseLeft = "0em";
    }
    const SceneOptions_performing = {triggerElement: "#performing_section", duration: "100%", triggerHook: 0};
    const performing_tween = new TimelineMax()
    .fromTo("#case_performing", 1, { left: "50em"}, { left: caseLeft, ease: Linear.easeNone })
    .fromTo("#string1_performing", 1, { left: 1500, opacity: 0}, { left: 0,opacity: 1, ease: Linear.easeNone })
    .fromTo("#string2_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#star1_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#spiral1_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#star2_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#spiral2_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#star3_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone });
    const performing_indicator = { name: "performing" };
    setAnimation(SceneOptions_performing, performing_tween, controller, performing_indicator);
}

function duxling_v2(controller){
    // SMARTER FEATURES
    const SceneOptions_smarter = {triggerElement: "#smarter_section", duration: "200%", triggerHook: 5};
    const smarter_tween = new TimelineMax()
    .fromTo("#case_smarter", 1, { left: 500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#bubbles_1", 1, { top: 50, opacity: 0}, { top:0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#bubbles_2", 1, { top:-50, opacity: 0}, { top:0, opacity: 1, ease: Linear.easeNone });
    const smarter_indicator = { name: "smarter" };
    setAnimation(SceneOptions_smarter, smarter_tween, controller, smarter_indicator);

    // INNOVATIVE
    const sceneOptions_inovative_options = { triggerElement: "#inovative", triggerHook: 50, duration: "100%" };
    let imagesRotating = [
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00000.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00002.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00004.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00006.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00008.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00010.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00012.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00014.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00016.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00018.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00020.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00022.png?v=1729892516",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_03_00023.png?v=1729892516",

    ];
    let objectRotating = { curImg: 0 };
    const tween_inovative_options = TweenMax.to(objectRotating, 0.5, {
        curImg: imagesRotating.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("inovative_img").src = imagesRotating[objectRotating.curImg];
        }
    });
    const indicatorOptions_inovative_options = { name: "rotatingImg" };
    setAnimation(sceneOptions_inovative_options, tween_inovative_options, controller, indicatorOptions_inovative_options)
  
    const sceneOptions_VIEWING_options = { triggerElement: "#viewing", triggerHook: 10, duration: "100%" };
    let imagesVIEWING = [
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00000.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00001.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00002.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00003.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00004.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00005.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00006.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00007.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00008.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00009.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00010.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00011.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00012.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00013.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00014.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00015.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00016.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00017.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00018.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00019.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00020.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00021.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00022.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00023.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00024.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00025.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00026.png?v=1729893661",
        "https://cdn.shopify.com/s/files/1/0731/2945/9948/files/STM_Duxling_04_00027.png?v=1729893661",

    ];
    let objectVIEWING = { curImg: 0 };
    const tween_VIEWING_options = TweenMax.to(objectVIEWING, 0.5, {
        curImg: imagesVIEWING.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("VIEWING_img").srcset = imagesVIEWING[objectVIEWING.curImg];
        }
    });
    const indicatorOptions_VIEWING_options = { name: "rotatingImg" };
    setAnimation(sceneOptions_VIEWING_options, tween_VIEWING_options, controller, indicatorOptions_VIEWING_options);

    // HIGH-PERFORMING
    let caseLeft = "5em";
    if(isMobile()){
        caseLeft = "0em";
    }
    const SceneOptions_performing = {triggerElement: "#performing_section", duration: "100%", triggerHook: 0};
    const performing_tween = new TimelineMax()
    .fromTo("#case_performing", 1, { left: "50em"}, { left: caseLeft, ease: Linear.easeNone })
    .fromTo("#string1_performing", 1, { left: 1500, opacity: 0}, { left: 0,opacity: 1, ease: Linear.easeNone })
    .fromTo("#string2_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#star1_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#spiral1_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#star2_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#spiral2_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#star3_performing", 1, { left: 1500, opacity: 0}, { left: 0, opacity: 1, ease: Linear.easeNone });
    const performing_indicator = { name: "performing" };
    setAnimation(SceneOptions_performing, performing_tween, controller, performing_indicator);
}

function isMobile2() {
    if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
    } else {
      return false
    }
}

function smarter(){    
    const controller = new ScrollMagic.Controller()
    TweenLite.defaultEase = Linear.easeNone
    var objRef = ''
    const intro = document.querySelector('#showcase')
    console.log(intro);
    const imageStatic = document.querySelector('.imgAnimatic')
    const showStatic = document.querySelector('.showcase-img')
    const showStatic2 = document.querySelector('.showcase-img2')
    var x = document.getElementsByClassName('only_ios')
    var element = document.querySelector('.wrapper')
    objRef = element.id

    if (document.querySelector('#video_smarter') != null) {
        let _video = document.querySelector('#video_smarter')
        if (isMobile2()){
            _video.style.display = 'none';
        }
        else{
            _video.style.display = 'block';
        }                
    }

    if (isMobile2()){
      if(intro !== null){
        intro.remove();
      }      
      return;
    }

    let pd = []
    let pagesdata = [{ name: 'smarter', vduration: 100, limit: 1, linkName: 'A Smarter way', link: '' }]

    switch (objRef) {
        case 'smarter':
            showStatic.remove()
            showStatic2.remove()
            // videoController();
            let showcase = document.querySelector('#showcase video')
            let playPromise = showcase.play()
            let frameRate = 24
            // In browsers that don’t yet support this functionality,
            // playPromise won’t be defined.
            if (playPromise !== undefined) {
                playPromise.catch(function () {
                let time = 0
                setInterval(() => {
                    if (time > showcase.duration) {
                    time = 0
                    } else {
                    time += 0.05
                    }
                    showcase.currentTime = time
                }, 1000 / frameRate)
                })
            }            
            document.querySelector('.VideoBannerLogo').style.display = 'none'
            videoControllerSmarter()
            smarterAnimations(controller)
            break
    }
}

function isScrolledIntoView(elem) {
    var docViewTop = jQuery(window).scrollTop()
    var docViewBottom = docViewTop + jQuery(window).height()
    var elemTop = jQuery(elem).offset().top
    return elemTop <= docViewBottom && elemTop >= docViewTop
}

function videoController(limit, vduration, controller) {  
  const intro = document.querySelector('#showcase')
  const video = intro.querySelector('video')
  const FrameInit = 1
  let FrameCheckpoint = limit
  let accelamout = 0.1
  let scrollPos = 0
  let delay = 0
  var counter = 0
  let scene = new ScrollMagic.Scene({
    duration: vduration,
    triggerElement: intro,
    triggerHook: 0,
  })
    .setPin(intro)
    .addTo(controller)
  scene.on('update', (e) => {
    scrollPos = e.scrollPos / 1000
  })
  video.loop = false
  setInterval(() => {
    if (counter <= FrameCheckpoint * 10) {
      counter += 0.05
      delay += (counter - delay) * accelamout
    } else {
      if (!video.paused) {
        video.pause()
      }
      delay += FrameCheckpoint + (scrollPos - delay) * accelamout
    }
    if (!video.paused && delay >= video.currentTime) {
      delay = video.currentTime
    }
    if (video.paused) {
      video.currentTime = delay
    }
  }, 43.3)
}

function videoControllerSmarter() {
    const intro = document.querySelector('#video_smarter')
    const video = intro.querySelector('video')
    const FrameInit = 1
    let FrameCheckpoint = 2
    let accelamout = 0.1
    let scrollPos = 0
    let delay = 0
    var counter = 0
    var view = false
    setInterval(() => {
      if (isScrolledIntoView('#video_smarter') || view == true) {
        if (counter <= FrameCheckpoint * 15) {
          counter += 0.05
          view = true
          delay += (counter - delay) * accelamout
        }
      }
      video.currentTime = delay
    }, 43.3)
}

function SectionAnimation(section, stTrigger, dt, th, tline, controller) {
    var tl = new TimelineMax()
    for (var a = 0; a < tline.length; a++) {
      tl.fromTo(
        tline[a].name,
        tline[a].dt,
        {
          opacity: tline[a].op1,
          xPercent: tline[a].xp1,
          yPercent: tline[a].yp1,
          scale: tline[a].sc1,
        },
        {
          opacity: tline[a].op2,
          xPercent: tline[a].xp2,
          yPercent: tline[a].yp2,
          scale: tline[a].sc2,
          ease: Linear.easeNone,
        },
        '+=1'
      )
    }
    let scene = new ScrollMagic.Scene({
      duration: dt,
      triggerElement: stTrigger,
      triggerHook: th,
    })
      .setTween(tl)
      .setPin(section)
      .addTo(controller)
}

function smarterAnimations(controller) {
    let twline = []
    var tween = new TimelineMax().fromTo( '.section04_text_01', 10, { yPercent: 10, opacity: 0 }, { yPercent: 0, opacity: 1 } )
    new ScrollMagic.Scene({ triggerElement: '.section04', triggerHook: 0.5, duration: 300, offset: 0 })
      .setTween(tween)
      .addTo(controller)
    twline = [
      { name: '.section05_text_01', dt: 5, op1: 1, xp1: 0, yp1: 10, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
      { name: '.section05_img_01', dt: 10, op1: 0.5, xp1: 0, yp1: 50, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
      { name: '.section05_text_02', dt: 10, op1: 0, xp1: 0, yp1: 100, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
      { name: '.section05_text_03', dt: 10, op1: 0, xp1: 0, yp1: -100, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
      { name: '.section05_text_04', dt: 10, op1: 0, xp1: 0, yp1: -100, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
    ]
    SectionAnimation('.section05', '.section05', '100%', 0, twline, controller)
    twline = [
      { name: '.sectionar_text', dt: 5, op1: 1, xp1: 0, yp1: 30, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
      { name: '.sectionar_img_01', dt: 10, op1: 0, xp1: 0, yp1: 100, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
      { name: '.sectionar_img_02', dt: 10, op1: 0, xp1: 0, yp1: 20, sc1: 0, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
    ]
    SectionAnimation('.sectionar', '.sectionar', '100%', 0, twline, controller)
}

function education(controller){
    // Care
    const SceneOptions_care = {triggerElement: ".section02", duration: 600, triggerHook: 0.75, reverse: true};
    const care_tween = new TimelineMax()
        .fromTo('.section02_text_01', 400, { opacity: 1, yPercent: 20 }, { opacity: 1, yPercent: 0 })
        .fromTo('.section02_img_01',  200, { opacity: 0.5, yPercent: -50 }, { opacity: 1, yPercent: 0 })
        .fromTo('.section02_img_02',  200, { opacity: 0.5, yPercent: 50 }, { opacity: 1, yPercent: 0 })
    const care_indicator = { name: "care" };
    setAnimation(SceneOptions_care, care_tween, controller, care_indicator);

    // passion
    const SceneOptions_passion = {triggerElement: ".section03_text_01", duration: 600, triggerHook: 0.75, reverse: true};
    const passion_tween = new TimelineMax()
        .fromTo(".section03_text_01", 600, { opacity: 0.25, yPercent: 20 }, { opacity: 1, yPercent: 0 })
    const passion_indicator = { name: "passion" };
    setAnimation(SceneOptions_passion, passion_tween, controller, passion_indicator);

    // PenHolder
    const SceneOptions_penHolder = {triggerElement: ".section04", duration: 400, triggerHook: 0, reverse: true};
    const penHolder_tween = new TimelineMax()
        .fromTo('.section04_img_02', 200, { opacity: 0, yPercent: 5 }, { opacity: 1, yPercent: 0 })
        .fromTo('.section04_img_01', 200, { opacity: 0, yPercent: 5 }, { opacity: 1, yPercent: 0 })
    const penHolder_indicator = { name: "penHolder" };
    setAnimation(SceneOptions_penHolder, penHolder_tween, controller, penHolder_indicator);

    // Trust
    const SceneOptions_trust = {triggerElement: ".section05", duration: 400, triggerHook: 0, reverse: true};
    const trust_tween = new TimelineMax()
        .fromTo('.section05_img_01', 400, { opacity: 0, yPercent: 5 }, { opacity: 1, yPercent: 0 })
    const trust_indicator = { name: "trust" };
    setAnimation(SceneOptions_trust, trust_tween, controller, trust_indicator);

    // Gallery
    const SceneOptions_gallery = {triggerElement: ".section06 ", duration: 600, triggerHook: 0, reverse: true};
    const gallery_tween = new TimelineMax()
        .fromTo('.section06_img_01', 200, { xPercent: -100 }, { xPercent: 0 })
        .fromTo('.section06_img_02', 200, { opacity: 0 }, { opacity: 1 })
        .fromTo('.section06_img_02', 200, { yPercent: -100 }, { yPercent: 0 })
        .fromTo('.section06_img_03', 200, { xPercent: -50 }, { xPercent: 0 })
    const gallery_indicator = { name: "gallery" };
    setAnimation(SceneOptions_gallery, gallery_tween, controller, gallery_indicator);

    // Guardian
    const SceneOptions_guardian = {triggerElement: ".section09_text_01", duration: 400, triggerHook: 0.75, reverse: true};
    const guardian_tween = new TimelineMax()
        .fromTo('.section09_text_01',600,{ opacity: 0, yPercent: -20 },{ opacity: 1, yPercent: 0 })
    const guardian_indicator = { name: "guardian" };
    setAnimation(SceneOptions_guardian, guardian_tween, controller, guardian_indicator);

  // SECURITY
    const SceneOptions_SECURITY = {triggerElement: ".section11", duration: 400, triggerHook: 0, reverse: true};
    const SECURITY_tween = new TimelineMax()
        .fromTo('.section11_img_01',600,{ opacity: 0 },{ opacity: 1 })
    const SECURITY_indicator = { name: "SECURITY" };
    setAnimation(SceneOptions_SECURITY, SECURITY_tween, controller, SECURITY_indicator);

}

function corporate(controller){
  // Confidence
  const SceneOptions_confidence = {triggerElement: ".section01", duration: 400, triggerHook: 0, reverse: true};
  const confidence_tween = new TimelineMax()
    .fromTo('.anim_img1_01', 600, {opacity: 0, xPercent: 100 },{opacity: 1, xPercent: 0 })
  const confidence_indicator = { name: "confidence" };
  setAnimation(SceneOptions_confidence, confidence_tween, controller, confidence_indicator);

  // From design to delivery and beyond
  const SceneOptions_fromDesign = {triggerElement: ".section1B", duration: 600, triggerHook: 0.5, reverse: true};
  const fromDesign_tween = new TimelineMax()
    .fromTo('.section1B_text_01', 600, {opacity: 0, yPercent: 10 }, {opacity: 1, yPercent: 40 })
  const fromDesign_indicator = { name: "fromDesign" };
  setAnimation(SceneOptions_fromDesign, fromDesign_tween, controller, fromDesign_indicator);

  // Protection
  const SceneOptions_protection = {triggerElement: ".section02", duration: 200, triggerHook: 0, reverse: true};
  const protection_tween = new TimelineMax()
    .fromTo('.anim_img2_01', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
  const protection_indicator = { name: "protection" };
  setAnimation(SceneOptions_protection, protection_tween, controller, protection_indicator);

  // Experience
  const SceneOptions_experience = {triggerElement: ".section03", duration: 400, triggerHook: 0, reverse: true};
  const experience_tween = new TimelineMax()
    .fromTo('.section03_text_01', 200, { yPercent: 0 }, { yPercent: 10 })
    .fromTo('.anim_img3_01', 200, { opacity: 0.5, xPercent: -100 }, { opacity: 1, xPercent: 20 })
  const experience_indicator = { name: "experience" };
  setAnimation(SceneOptions_experience, experience_tween, controller, experience_indicator);

  // Value
  const SceneOptions_value = {triggerElement: ".section04", duration: 600, triggerHook: 0, reverse: true};
  const value_tween = new TimelineMax()
    .fromTo('.section04_img_01', 200, { opacity: 0, scale: 0.5 }, { opacity: 1, scale: 1 })
    .fromTo('.section04_img_02', 200, { opacity: 0, scale: 0.5 }, { opacity: 1, scale: 1 })
    .fromTo('.section04_img_03', 200, { opacity: 0, scale: 0.5 }, { opacity: 1, scale: 1 })
  const value_indicator = { name: "value" };
  setAnimation(SceneOptions_value, value_tween, controller, value_indicator);  

  // Expertise
  const SceneOptions_expertise = {triggerElement: ".section05", duration: 600, triggerHook: 0, reverse: true};
  const expertise_tween = new TimelineMax()
    .fromTo('.anim_img5_01', 600, { xPercent: 50 }, { xPercent: 0 })
  const expertise_indicator = { name: "expertise" };
  setAnimation(SceneOptions_expertise, expertise_tween, controller, expertise_indicator); 

  // Business
  const SceneOptions_business = {triggerElement: ".section05B", duration: 400, triggerHook: 0.5, reverse: true};
  const business_tween = new TimelineMax()
    .fromTo('.section05B_text_01', 400, {opacity: 0, yPercent: 10 },{ opacity: 1, yPercent: 40 })
  const business_indicator = { name: "business" };
  setAnimation(SceneOptions_business, business_tween, controller, business_indicator);

  // Smart
  const SceneOptions_smart = {triggerElement: ".section06", duration: 600, triggerHook: 0, reverse: true};
  const smart_tween = new TimelineMax()
    .fromTo('.anim_img6_01', 400,{ opacity: 0, scale: 3, yPercent: -50 },{ opacity: 1, scale: 1.5, yPercent: 0 })
  const smart_indicator = { name: "smart" };
  setAnimation(SceneOptions_smart, smart_tween, controller, smart_indicator);

  // Security
  const SceneOptions_security = {triggerElement: ".section07", duration: 400, triggerHook: 0, reverse: true};
  const security_tween = new TimelineMax()
    .fromTo('.anim_img7_01', 200, { opacity: 0, yPercent: -100, xPercent: 100 },{ opacity: 1, yPercent: 0, xPercent: 0 })
    .fromTo('.anim_img7_02', 200, { opacity: 0, yPercent: 100, xPercent: -100 },{ opacity: 1, yPercent: 0, xPercent: 0 })
  const security_indicator = { name: "security" };
  setAnimation(SceneOptions_security, security_tween, controller, security_indicator);
}

function dux_swivel(controller) {
    // Rugged protection circle
    const SceneOptions_protectionCircle = {triggerElement: "#div_down_circle", duration: "50%", triggerHook: -200};
    const protectionCircle_tween = TweenMax.fromTo("#div_down_circle", 1, { borderRadius: "0, 0, 0, 0"}, { borderRadius: "0, 0, 60%, 60%", ease: Linear.easeNone });
    const protectionCircle_indicator = { name: "protection_circle" };
    setAnimation(SceneOptions_protectionCircle, protectionCircle_tween, controller, protectionCircle_indicator);

    // Rugged Protection
    const ruggedProtection_options = {triggerElement: "#ruggedProtection",  duration: "100%"};
    const ruggedProtection_tween = new TimelineMax()
    .fromTo("#ruggedProtection_img", 1, { top: -1000 }, { top: 0, ease: Linear.easeNone })
    .fromTo("#ruggedProtection_title", 1, { left: -1000, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone});
    const ruggedProtection_indicator = { name: "rugged Protection" };
    setAnimation(ruggedProtection_options, ruggedProtection_tween, controller, ruggedProtection_indicator);

    // rotating stand
    const sceneOptions_rotatingStand_options = { triggerElement: "#rotatingStand", triggerHook: 0, duration: "100%" };
    let imagesRotating = [
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00000.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00002.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00004.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00006.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00008.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00010.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00012.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00014.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00016.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00018.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00020.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00022.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00024.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00026.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00028.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00030.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00032.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00034.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00036.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00038.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00040.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00042.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00044.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00046.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_003_00047.png",
    ];
    let objectRotating = { curImg: 0 };
    const tween_rotatingStand_options = TweenMax.to(objectRotating, 0.5, {
        curImg: imagesRotating.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("rotatingImg").srcset = imagesRotating[objectRotating.curImg];
        }
    });
    const indicatorOptions_rotatingStand_options = { name: "rotatingImg" };
    setAnimation(sceneOptions_rotatingStand_options, tween_rotatingStand_options, controller, indicatorOptions_rotatingStand_options);

    // Storage
    const sceneOptions_Storage = { triggerElement: "#storage", triggerHook: 0, duration: "100%" };
    let images = [
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00000.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00002.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00004.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00006.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00008.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00010.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00012.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00014.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00016.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00018.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00020.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00022.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00024.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00026.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00028.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00030.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00032.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00034.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00036.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00038.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00040.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00042.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00044.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00046.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_DuxSwivel_004_00047.png",
    ];
    let obj = { curImg: 0 };
    const tween_Storage = TweenMax.to(obj, 0.5, {
        curImg: images.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("storageImg").srcset = images[obj.curImg];
        }
    });
    const indicatorOptions_Storage = { name: "storageImg" };
    setAnimation(sceneOptions_Storage, tween_Storage, controller, indicatorOptions_Storage);

    // diagonal
    const SceneOptions_diagonal = {triggerElement: "#diagonal", duration: "50%", triggerHook: 200};
    const diagonal_tween = TweenMax.fromTo(".orangeGradient_diagonal", 1, { "--beforeTransform": "skewy(0deg)"}, { "--beforeTransform": "skewy(-10deg)", ease: Linear.easeNone });
    const diagonal_indicator = { name: "diagonal" };
    setAnimation(SceneOptions_diagonal, diagonal_tween, controller, diagonal_indicator);

    // sturdy
    const SceneOptions_sturdy = {triggerElement: "#diagonal", duration: "100%", triggerHook: 300};
    const sturdy_tween = TweenMax.fromTo(".sturdyImg", 1, { transform: "rotate(130deg)"}, { transform: "rotate(0deg)", ease: Linear.easeNone });
    const sturdy_indicator = { name: "sturdy" };
    setAnimation(SceneOptions_sturdy, sturdy_tween, controller, sturdy_indicator);

    // strap
    const SceneOptions_strap = {triggerElement: "#strap_section", duration: "100%", triggerHook: 0};
    const strap_tween = new TimelineMax()
    .fromTo("#case_img", 1, { opacity: "1"}, { opacity: "0.75", ease: Linear.easeNone })
    .fromTo("#strap_img", 1, { opacity: "0"}, { opacity: "1", ease: Linear.easeNone });
    const strap_indicator = { name: "strap" };
    setAnimation(SceneOptions_strap, strap_tween, controller, strap_indicator);
}

function focus_roll(controller){
    // FOCUSROLL Circle
    const SceneOptions_FOCUSROLLCircle = {triggerElement: "#div_down_circle", duration: "50%", triggerHook: -200};
    const FOCUSROLLCircle_tween = TweenMax.fromTo("#div_down_circle", 1, { borderRadius: "0, 0, 0%, 50%"}, { borderRadius: "0, 0, 50%, 50%", ease: Linear.easeNone });    
    const FOCUSROLLCircle_indicator = { name: "FOCUSROLL_circle" };
    setAnimation(SceneOptions_FOCUSROLLCircle, FOCUSROLLCircle_tween, controller, FOCUSROLLCircle_indicator);

    // CalmPromoting 
    const SceneOptions_CalmPromoting = {triggerElement: "#CalmPromoting", duration: "50%", triggerHook: -200};
    const CalmPromoting_tween = TweenMax.fromTo("#CalmPromotingImg", 1, { top: "300px"}, { top: "0", ease: Linear.easeNone });
    const CalmPromoting_indicator = { name: "CalmPromoting" };
    setAnimation(SceneOptions_CalmPromoting, CalmPromoting_tween, controller, CalmPromoting_indicator);

     // CalmPromoting Sequence
     const sceneOptions_CalmPromoting_sec = { triggerElement: "#CalmPromotingImg", triggerHook: 50, duration: "200%" };
     let imagesCalmPromoting = [
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00000.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00001.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00002.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00003.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00004.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00005.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00006.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00007.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00008.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00009.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00010.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00011.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00012.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00013.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00014.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00015.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00016.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00017.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00018.png",
         "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_02_00019.png",
     ];
     let objCalmPromoting = { curImg: 0 };
     const tween_CalmPromoting_sec = TweenMax.to(objCalmPromoting, 1, {
         curImg: imagesCalmPromoting.length - 1,
         roundProps: "curImg",
         immediateRender: true,
         repeat: -1,
         ease: Linear.easeNone,
         onUpdate: function () {
            document.getElementById("CalmPromotingImg").src = imagesCalmPromoting[objCalmPromoting.curImg];
         }
     });
     const indicatorOptions_CalmPromoting_sec = { name: "CalmPromoting_img" };
     setAnimation(sceneOptions_CalmPromoting_sec, tween_CalmPromoting_sec, controller, indicatorOptions_CalmPromoting_sec);

    // independent Buttons
    const independentButtons_options = {triggerElement: "#independent_buttons", triggerHook: 0, duration: "100%"};
    const independentButtons_tween = new TimelineMax()
    .fromTo("#independent_buttons_base", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#independent_buttons_circle", 1, { scale: 0, opacity: 0 , transformOrigin: "300px 200px"}, { scale: 1, opacity: 1, transformOrigin: "300px 200px", ease: Linear.easeNone });
    const independentButtons_indicator = { name: "Drop Protection" };
    setAnimation(independentButtons_options, independentButtons_tween, controller, independentButtons_indicator);

     // 360º rotating
     const rotating_options = {triggerElement: "#rotating", triggerHook: 0, duration: "100%"};
     const rotating_tween = new TimelineMax()
     .fromTo("#rotating_img", 1, { left: -200, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone })
    //  .fromTo("#independent_buttons_circle", 1, { scale: 0, opacity: 0 , transformOrigin: "300px 200px"}, { scale: 1, opacity: 1, transformOrigin: "300px 200px", ease: Linear.easeNone });
     const rotating_indicator = { name: "rotating" };
     setAnimation(rotating_options, rotating_tween, controller, rotating_indicator);

    // rotating Sequence
    const sceneOptions_rotating_sec = { triggerElement: "#rotating", triggerHook: 0, duration: "100%" };
    let images = [
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00000.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00001.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00002.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00003.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00004.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00005.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00006.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00007.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00008.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00009.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00010.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00011.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00012.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00013.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00014.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00015.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00016.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00017.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00018.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00019.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00020.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00021.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00022.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00023.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00024.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00025.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00026.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00027.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00028.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00029.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00030.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00031.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00032.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00033.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00034.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Roll_04_00035.png",
    ];
    let obj = { curImg: 0 };
    const tween_rotating_sec = TweenMax.to(obj, 0.5, {
        curImg: images.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("rotating_img").src = images[obj.curImg];
        }
    });
    const indicatorOptions_rotating_sec = { name: "rotating_img" };
    setAnimation(sceneOptions_rotating_sec, tween_rotating_sec, controller, indicatorOptions_rotating_sec);

    // impact performing
    const SceneOptions_impact_performing = {triggerElement: "#impact_performing", duration: "100%", triggerHook: -200};
    // const impact_performing_tween = TweenMax.fromTo("#impact_performing_case", 1, { bottom: "300px", opacity: 0}, { bottom: "0", opacity: 1, ease: Linear.easeNone });
    const impact_performing_tween = new TimelineMax()
    .fromTo("#impact_performing_ground", 1, { bottom: -100, opacity: 0 }, { bottom: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#impact_performing_case", 5, { top: -100, opacity: 0 }, { top: 0, opacity: 1, ease:Elastic.easeOut.config(1,0.4)});
    const impact_performing_indicator = { name: "impact_performing" };
    setAnimation(SceneOptions_impact_performing, impact_performing_tween, controller, impact_performing_indicator);

    // IMPACT PERFORMING Circle
    const SceneOptions_IMPACTPERFORMINGCircle = {triggerElement: "#div_down_circle_black", duration: "50%", triggerHook: -200};
    const IMPACTPERFORMINGCircle_tween = TweenMax.fromTo("#div_down_circle_black", 1, { borderRadius: "0, 0, 0, 0"}, { borderRadius: "0, 0, 60%, 60%", ease: Linear.easeNone });
    const IMPACTPERFORMINGCircle_indicator = { name: "IMPACTPERFORMING_circle" };
    setAnimation(SceneOptions_IMPACTPERFORMINGCircle, IMPACTPERFORMINGCircle_tween, controller, IMPACTPERFORMINGCircle_indicator);


}

function chargeTreeMag(controller) {
  let triggerhook = 0;
  if(navigator.userAgent.includes("Mac") && "ontouchend" in document){
    triggerhook = 0.6;
  }
    // Fold Compactly Sequence
    const sceneOptions_foldCompactly = { triggerElement: "#foldsCompactly", triggerHook: triggerhook, duration: 400 }; //100
    let images = [
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_01.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_02.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_03.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_04.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_05.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_06.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_07.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_08.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_09.jpg",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/STM_Chargetree_Mag_02_10.jpg",
    ];
    let obj = { curImg: 0 };
    const tween_foldCompactly = TweenMax.to(obj, 0.5, {
        curImg: images.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("picture").srcset = images[obj.curImg];
        }
    });
    const indicatorOptions_foldCompactly = { name: "fold compac" };
    setAnimation(sceneOptions_foldCompactly, tween_foldCompactly, controller, indicatorOptions_foldCompactly);

    // 3 in 1
    const SceneOptions_3in1 = { triggerElement: "#CharginPlatform", duration: 400 }; //100
    const tween_3in1 = TweenMax.fromTo("#animate1", 1, { left: 500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const indicatorOptions_3in1 = { name: "3 in 1" };
    setAnimation(SceneOptions_3in1, tween_3in1, controller, indicatorOptions_3in1);

    // black section
    if(isMobile()){
        let pinOrange = document.getElementById("sectionBlack");
        new ScrollMagic.Scene({triggerElement: pinOrange, triggerHook: 0, duration: "150%"}).setPin(pinOrange).addTo(controller);
        const sectioncableBlack = {triggerElement: "#sectionBlack", triggerHook: 0,  duration: "150%"};
        const tween_Cable_black = new TimelineMax()
        .fromTo("#row-1", 1, {top:"0%"}, {top:"0%"})
        .fromTo("#cable_black_mobile", 1, {top:"50%", opacity:0}, {top:"0", opacity:1})
        .fromTo("#row-2", 1, {top:"50%", opacity:0}, {top:"5vw", opacity:1});
        const indicatorOptions_Cable = { name: "Cable" };
        setAnimation(sectioncableBlack, tween_Cable_black, controller, indicatorOptions_Cable);
    }
    else{
        let pinOrange = document.getElementById("sectionBlack");
        new ScrollMagic.Scene({triggerElement: pinOrange, triggerHook: 0, duration: "200%"}).setPin(pinOrange).addTo(controller);
        const sectioncableBlack = {triggerElement: "#sectionBlack", triggerHook: 0,  duration: "200%"};
        const tween_Cable_black = new TimelineMax()
        .fromTo("#row-1", 1, {left:"0%"}, {left:"-90%"})
        .fromTo("#row-1", 1, {top:"0%"}, {top:"-20%"})
        .fromTo("#row-2", 1, {top:"0%", opacity:0}, {top:"-15%", opacity:1});
        const indicatorOptions_Cable = { name: "Cable" };
        setAnimation(sectioncableBlack, tween_Cable_black, controller, indicatorOptions_Cable);
    }

    // specs
    const SceneOptions_specs = { triggerElement: "#Specs", duration: 400, triggerHook: triggerhook }; //100%
    const tween_specs = TweenMax.fromTo("#specsimg", 1, { left: 500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const indicatorOptions_specs = { name: "3 in 1" };
    setAnimation(SceneOptions_specs, tween_specs, controller, indicatorOptions_specs);
}

function backPack2023(controller) {
    // Ruggedly durable
    const SceneOptions_ruggedly = {triggerElement: "#section_ruggedly", triggerHook: 0, duration: "100%"};
    const tween_ruggedly = new TimelineMax()
    .fromTo("#img_ruggedly", 1, {top: -500, opacity: 0}, {top: 0, opacity: 1, ease: Linear.easeNone})
    .fromTo("#ellipse1", 1, {scale: 0, opacity: 0}, {scale: 1, opacity: 1, ease: Linear.easeNone});
    const indicatorOptions_ruggedly = { name: "Ruggedly" };
    setAnimation(SceneOptions_ruggedly, tween_ruggedly, controller, indicatorOptions_ruggedly);

    // FRONT ZIPPER POCKET & POUCH
    const SceneOptions_front_zipper = {triggerElement: "#section_front_zipper", triggerHook: 0, duration: "100%"};
    const tween_front_zipper = new TimelineMax()
    .fromTo("#img_front_zipper", 1, {left: -500, opacity: 0}, {left: 0, opacity: 1, ease: Linear.easeNone})
    .fromTo("#img_pocket", 1, {left: "150%", opacity: 0}, {left: "95%", opacity: 1, ease: Linear.easeNone});
    const indicatorOptions_front_zipper = { name: "section_front_zipper" };
    setAnimation(SceneOptions_front_zipper, tween_front_zipper, controller, indicatorOptions_front_zipper);

    // FRONT ZIPPER POCKET & POUCH mobile
    const SceneOptions_front_zipper_mobile = {triggerElement: "#section_front_zipper", triggerHook: 0, duration: "100%"};
    const tween_front_zipper_mobile = new TimelineMax()
    .fromTo("#img_front_zipper_mobile", 1, {left: -500, opacity: 0}, {left: 0, opacity: 1, ease: Linear.easeNone})
    .fromTo("#img_pocket_mobile", 1, {left: "150%", opacity: 0}, {left: "45%", opacity: 1, ease: Linear.easeNone});
    const indicatorOptions_front_zipper_mobile = { name: "section_front_zipper_mobile" };
    setAnimation(SceneOptions_front_zipper_mobile, tween_front_zipper_mobile, controller, indicatorOptions_front_zipper_mobile);


    // Comfortable
    const SceneOptions_comfortable = {triggerElement: "#section_comfortable", triggerHook: 0, duration: "100%"};
    const tween_comfortable = TweenMax.fromTo("#img_comfortable", 1, {bottom: -1000, opacity: 0}, {bottom: 0, opacity: 1, ease: Linear.easeNone});
    const indicatorOptions_comfortable = { name: "Comfortable" };
    setAnimation(SceneOptions_comfortable, tween_comfortable, controller, indicatorOptions_comfortable);

    // BAGPACK_FOLDING Sequence
    const sceneOptions_BAGPACK_FOLDING = { triggerElement: "#section_orange", triggerHook: 0, duration: "300%" };
    let images = [
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00001.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00002.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00003.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00004.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00005.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00006.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00007.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00008.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00009.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00010.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00011.png",
        "https://cdn.shopify.com/s/files/1/0932/2224/0538/files/BAGPACK_FOLDING_ANIMATION_V001_00012.png",
    ];
    let obj = { curImg: 0 };
    const tween_BAGPACK_FOLDING = TweenMax.to(obj, 0.5, {
        curImg: images.length - 1,
        roundProps: "curImg",
        immediateRender: true,
        ease: Linear.easeNone,
        onUpdate: function () {
            document.getElementById("orangePicture").src = images[obj.curImg];
        }
    });
    const indicatorOptions_BAGPACK_FOLDING = { name: "BAGPACK_FOLDING" };
    setAnimation(sceneOptions_BAGPACK_FOLDING, tween_BAGPACK_FOLDING, controller, indicatorOptions_BAGPACK_FOLDING);

    // Orange
    let pinOrange = document.getElementById("section_orange");
    new ScrollMagic.Scene({triggerElement: pinOrange, triggerHook: 0, duration: "300%"}).setPin(pinOrange).addTo(controller);

    const SceneOptions_orange = {triggerElement: "#section_orange", triggerHook: 0,  duration: "300%"};
    const tween_orange = new TimelineMax()
    .fromTo("#text_orange1", 1, {bottom: -500, opacity: 0}, {bottom: 60, opacity: 1, ease: Linear.easeNone, display:"block"})
    .fromTo("#text_orange1", 1, {bottom: 60, opacity: 1}, {bottom: 60, opacity: 1, duration:100})
    .fromTo("#text_orange1", 1, {bottom: 60, opacity: 1}, {bottom: 100, opacity: 0, ease: Linear.easeNone})
    .fromTo("#text_orange2", 1, {bottom: -500, opacity: 0}, {bottom: 60, opacity: 1, ease: Linear.easeNone, display:"block"})
    .fromTo("#text_orange2", 1, {bottom: 60, opacity: 1}, {bottom: 60, opacity: 1, duration:100})
    .fromTo("#text_orange2", 1, {bottom: 60, opacity: 1}, {bottom: 100, opacity: 0, ease: Linear.easeNone})
    .fromTo("#text_orange3", 1, {bottom: -500, opacity: 0}, {bottom: 60, opacity: 1, ease: Linear.easeNone, display:"block"})
    .fromTo("#text_orange3", 1, {bottom: 60, opacity: 1}, {bottom: 60, opacity: 1, duration:100})
    const indicatorOptions_orange = { name: "Orange" };
    setAnimation(SceneOptions_orange, tween_orange, controller, indicatorOptions_orange);

    // Durable Zippers
    const SceneOptions_zipper = {triggerElement: "#section_zipper", triggerHook: 0, duration: "100%"};
    const tween_zipper = new TimelineMax()
    .fromTo("#img_zipper", 1, {bottom: -500, opacity: 0}, {bottom: 0, opacity: 1, ease: Linear.easeNone})
    .fromTo("#ellipse2", 1, {scale: 0, opacity: 0}, {scale: 1, opacity: 1, ease: Linear.easeNone});
    const indicatorOptions_zipper = { name: "zipper" };
    setAnimation(SceneOptions_zipper, tween_zipper, controller, indicatorOptions_zipper);

    // Bag & Things
    const SceneOptions_box = {triggerElement: "#imagesBox", triggerHook: 0, duration: "100%"};
    const tween_box = new TimelineMax()
    .fromTo("#pos1", 1, {bottom: -500, opacity: 0, display:"none"}, {bottom: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos2", 1, {left: -500, opacity: 0, display:"none"}, {left: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos3", 1, {left: -500, opacity: 0, display:"none"}, {left: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos4", 1, {top: -500, opacity: 0, display:"none"}, {top: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos5", 1, {top: -500, opacity: 0, display:"none"}, {top: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos6", 1, {right: -500, opacity: 0, display:"none"}, {right: 0, opacity: 1, display:"block", ease: Linear.easeNone});
    const indicatorOptions_box = { name: "box" };
    setAnimation(SceneOptions_box, tween_box, controller, indicatorOptions_box);

    // Bag & Things mobile
    const SceneOptions_box_mobile = {triggerElement: "#imagesBox-mobile", triggerHook: 0, duration: "100%"};
    const tween_box_mobile = new TimelineMax()
    .fromTo("#pos1-mobile", 1, {bottom: -500, opacity: 0, display:"none"}, {bottom: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos2-mobile", 1, {top: -500, opacity: 0, display:"none"}, {top: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos3-mobile", 1, {top: -500, opacity: 0, display:"none"}, {top: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos4-mobile", 1, {top: -500, opacity: 0, display:"none"}, {top: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos5-mobile", 1, {bottom: -500, opacity: 0, display:"none"}, {bottom: 0, opacity: 1, display:"block", ease: Linear.easeNone})
    .fromTo("#pos6-mobile", 1, {bottom: -500, opacity: 0, display:"none"}, {bottom: 0, opacity: 1, display:"block", ease: Linear.easeNone});
    const indicatorOptions_box_mobile = { name: "box" };
    setAnimation(SceneOptions_box_mobile, tween_box_mobile, controller, indicatorOptions_box_mobile);

    // SPACE
    const SceneOptions_space = {triggerElement: "#space", duration: "100%"};
    const tween_space = TweenMax.fromTo("#spaceimg", 1, {left: -500, opacity: 0}, {left: 0, opacity: 1, ease: Linear.easeNone});
    const indicatorOptions_space = { name: "space" };
    setAnimation(SceneOptions_space, tween_space, controller, indicatorOptions_space);

    // Specs
    const specs_options = {triggerElement: "#Specs", triggerHook: 0, duration: "100%"};
    const specs_tween = TweenMax.fromTo("#specs_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    const specs_indicator = { name: "Drop Protection" };
    setAnimation(specs_options, specs_tween, controller, specs_indicator);
}

function reawaken(controller){
    const circle_options = {triggerElement: "#circles1", triggerHook: 100, duration: "100%"};
    const circle_tween = new TimelineMax()
    .fromTo("#circle1", 1, { bottom: -200, opacity: 0 }, { bottom: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#circle2", 1, { bottom: -200, opacity: 0 }, { bottom: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#circle3", 1, { bottom: -200, opacity: 0 }, { bottom: 0, opacity: 1, ease: Linear.easeNone });
    const circle_indicator = { name: "circles" };
    setAnimation(circle_options, circle_tween, controller, circle_indicator);

    const dropProtection_options = {triggerElement: "#dropProtection", triggerHook: 0, duration: "100%"};
    // const dropProtection_tween = TweenMax.fromTo("#dropProtection_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    const dropProtection_tween = new TimelineMax()
    .fromTo("#dropProtection_ground", 1, { bottom: -100, opacity: 0 }, { bottom: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#dropProtection_case", 5, { top: -100, opacity: 0 }, { top: 0, opacity: 1, ease:Elastic.easeOut.config(1,0.4)});
    const dropProtection_indicator = { name: "Drop Protection" };
    setAnimation(dropProtection_options, dropProtection_tween, controller, dropProtection_indicator);

    const clearShellPlating_options = {triggerElement: "#clearShellPlating", triggerHook: 0, duration: "100%"};
    const clearShellPlating_tween = new TimelineMax()
    .fromTo("#clearShellPlating_img", 1, { left: -500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#clearShellPlating_case", 1, { top: -400, opacity: 0 }, { top: 0, opacity: 1, ease: Linear.easeNone });
    const clearShellPlating_indicator = { name: "Drop Protection" };
    setAnimation(clearShellPlating_options, clearShellPlating_tween, controller, clearShellPlating_indicator);

    const easyStore_options = {triggerElement: "#easyStore", triggerHook: 0, duration: "100%"};
    const easyStore_tween = new TimelineMax()
    .fromTo("#easyStore_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    // .fromTo("#easyStore_elipse", 1, { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, ease: Linear.easeNone });
    const easyStore_indicator = { name: "easy Store" }
    setAnimation(easyStore_options, easyStore_tween, controller, easyStore_indicator);

    const comfortable_options = {triggerElement: "#comfortable", triggerHook: 0, duration: "100%"};
    const comfortable_tween = TweenMax.fromTo("#comfortable_img", 1, { left: -500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const comfortable_indicator = { name: "Drop Protection" };
    setAnimation(comfortable_options, comfortable_tween, controller, comfortable_indicator);

    const specs_options = {triggerElement: "#Specs", triggerHook: 0, duration: "100%"};
    const specs_tween = TweenMax.fromTo("#specs_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    const specs_indicator = { name: "Drop Protection" };
    setAnimation(specs_options, specs_tween, controller, specs_indicator);
}

function relax(controller){

    const dropProtection_options = {triggerElement: "#dropProtection", triggerHook: 0, duration: "100%"};
    const dropProtection_tween = new TimelineMax()
    .fromTo("#dropProtection_ground", 1, { bottom: -100, opacity: 0 }, { bottom: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#dropProtection_case", 5, { top: -100, opacity: 0 }, { top: 0, opacity: 1, ease:Elastic.easeOut.config(1,0.4)});
    const dropProtection_indicator = { name: "Drop Protection" };
    setAnimation(dropProtection_options, dropProtection_tween, controller, dropProtection_indicator);

    const comfortable_options = {triggerElement: "#comfortable", triggerHook: 0, duration: "100%"};
    const comfortable_tween = TweenMax.fromTo("#comfortable_img", 1, { left: -500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const comfortable_indicator = { name: "Drop Protection" };
    setAnimation(comfortable_options, comfortable_tween, controller, comfortable_indicator);

    const easyStore_options = {triggerElement: "#easyStore", triggerHook: 0, duration: "100%"};
    const easyStore_tween = TweenMax.fromTo("#easyStore_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    const easyStore_indicator = { name: "Drop Protection" };
    setAnimation(easyStore_options, easyStore_tween, controller, easyStore_indicator);

    const clearShellPlating_options = {triggerElement: "#clearShellPlating", triggerHook: 0, duration: "100%"};
    const clearShellPlating_tween = TweenMax.fromTo("#clearShellPlating_img", 1, { left: -500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const clearShellPlating_indicator = { name: "Drop Protection" };
    setAnimation(clearShellPlating_options, clearShellPlating_tween, controller, clearShellPlating_indicator);

    const specs_options = {triggerElement: "#Specs", triggerHook: 0, duration: "100%"};
    const specs_tween = TweenMax.fromTo("#specs_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    const specs_indicator = { name: "Drop Protection" };
    setAnimation(specs_options, specs_tween, controller, specs_indicator);

}

function reveal(controller){
    const dropProtection_options = {triggerElement: "#dropProtection", triggerHook: 0, duration: "100%"};
    // const dropProtection_tween = TweenMax.fromTo("#dropProtection_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    const dropProtection_tween = new TimelineMax()
    .fromTo("#dropProtection_ground", 1, { bottom: -100, opacity: 0 }, { bottom: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#dropProtection_case", 5, { top: -100, opacity: 0 }, { top: 0, opacity: 1, ease:Elastic.easeOut.config(1,0.4)});
    const dropProtection_indicator = { name: "Drop Protection" };
    setAnimation(dropProtection_options, dropProtection_tween, controller, dropProtection_indicator);

    const clearShellPlating_options = {triggerElement: "#clearShellPlating", triggerHook: 0, duration: "100%"};
    const clearShellPlating_tween = TweenMax.fromTo("#clearShellPlating_img", 1, { left: -500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const clearShellPlating_indicator = { name: "Drop Protection" };
    setAnimation(clearShellPlating_options, clearShellPlating_tween, controller, clearShellPlating_indicator);

    const independentButtons_options = {triggerElement: "#independentButtons", triggerHook: 0, duration: "100%"};
    const independentButtons_tween = new TimelineMax()
    .fromTo("#independentButtons_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone })
    .fromTo("#independentButtons_elipse", 1, { scale: 0, opacity: 0 }, { scale: 1, opacity: 1, ease: Linear.easeNone });
    const independentButtons_indicator = { name: "Drop Protection" };
    setAnimation(independentButtons_options, independentButtons_tween, controller, independentButtons_indicator);

    const comfortable_options = {triggerElement: "#comfortable", triggerHook: 0, duration: "100%"};
    const comfortable_tween = TweenMax.fromTo("#comfortable_img", 1, { left: -500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const comfortable_indicator = { name: "Drop Protection" };
    setAnimation(comfortable_options, comfortable_tween, controller, comfortable_indicator);

    const specs_options = {triggerElement: "#Specs", triggerHook: 0, duration: "100%"};
    const specs_tween = TweenMax.fromTo("#specs_img", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    const specs_indicator = { name: "Drop Protection" };
    setAnimation(specs_options, specs_tween, controller, specs_indicator);
}

function dux_backpack_16l(controller){
    // SIDE WING POCKETS
    const sideWingPockets_options = {triggerElement: "#sideWingPockets", triggerHook: 0, duration: "100%"};
    const sideWingPockets_tween = TweenMax.fromTo("#sideWingPocketsImg", 1, { left: -500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const sideWingPockets_indicator = { name: "sideWingPockets" };
    setAnimation(sideWingPockets_options, sideWingPockets_tween, controller, sideWingPockets_indicator);
    // MULTIPLE POCKETS
    const multiplepockets_options = {triggerElement: "#multiplepockets", triggerHook: 0, duration: "100%"};
    const multiplepockets_tween = TweenMax.fromTo("#multiplepocketsImg", 1, { right: -500, opacity: 0 }, { right: 0, opacity: 1, ease: Linear.easeNone });
    const multiplepockets_indicator = { name: "multiplepockets" };
    setAnimation(multiplepockets_options, multiplepockets_tween, controller, multiplepockets_indicator);
    // THE SMARTER BACKPACK
    // features
    const SceneOptions_features = {triggerElement: "#features", triggerHook: 0, duration: "100%"};
    const tween_features = new TimelineMax()
    .fromTo("#line1", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    .fromTo("#gridSmarterBackpackTxt01", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    .fromTo("#line2", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    .fromTo("#gridSmarterBackpackTxt02", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    .fromTo("#circle", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    .fromTo("#line3", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    .fromTo("#gridSmarterBackpackTxt03", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    .fromTo("#line4", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    .fromTo("#gridSmarterBackpackTxt04", 1, {opacity: 0}, {opacity: 1, ease: Linear.easeNone})
    const indicatorOptions_features = { name: "features" };
    setAnimation(SceneOptions_features, tween_features, controller, indicatorOptions_features);
    // ComfortCarry
    const ComfortCarry_options = {triggerElement: "#ComfortCarry", triggerHook: 0, duration: "100%"};
    const ComfortCarry_tween = TweenMax.fromTo("#ComfortCarryImg", 1, { bottom: -500 }, { bottom: 0, ease: Linear.easeNone });
    const ComfortCarry_indicator = { name: "ComfortCarry" };
    setAnimation(ComfortCarry_options, ComfortCarry_tween, controller, ComfortCarry_indicator);
    // Colors
    const colors_options = {triggerElement: "#colors", triggerHook: 0, duration: "100%"};
    const colors_tween = TweenMax.fromTo("#colors-carousel", 1, { left: -500, opacity: 0 }, { left: 0, opacity: 1, ease: Linear.easeNone });
    const colors_indicator = { name: "colors" };
    setAnimation(colors_options, colors_tween, controller, colors_indicator);
}

function duxStudio(controller){
  let twline = []
  twline = [{ name: '.section01_img_01', dt: 5, op1: 0, xp1: 0, yp1: -150, op2: 1, xp2: 0, yp2: 0 }]
  SectionAnimation('.section01', '.section01', '100%', 0, twline, controller)
  twline = [
    { name: '.section02_img_01', dt: 10, op1: 1, xp1: 0, yp1: -30, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section02_img_02', dt: 10, op1: 1, xp1: 0, yp1: -20, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section02_img_03', dt: 10, op1: 0, xp1: 0, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section02_text_01', dt: 5, op1: 0.75, xp1: 0, yp1: -60, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section02_text_02', dt: 5, op1: 0.5, xp1: 0, yp1: -50, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section02_text_03', dt: 5, op1: 0.25, xp1: 0, yp1: -40, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section02', '.section02', '100%', 0, twline, controller)
  twline = [
    { name: '.section04_text_01', dt: 5, op1: 0.5, xp1: 0, yp1: 50, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04_img_01', dt: 5, op1: 0.25, xp1: '100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04_img_02', dt: 10, op1: 1, xp1: 0, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section04', '.section04', '100%', 0, twline, controller)
  twline = [
    { name: '.section04B_img_01', dt: 6, op1: 0, xp1: -150, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04B_text_01', dt: 5, op1: 0.5, xp1: 0, yp1: 40, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04B_text_02', dt: 5, op1: 0.25, xp1: 0, yp1: 60, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04B_img_02', dt: 6, op1: 0, xp1: 150, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section04B', '.section04B', '100%', 0, twline, controller)
  twline = [
    { name: '.section05_text_02', dt: 5, op1: 0.5, xp1: 0, yp1: 40, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section05_text_03', dt: 5, op1: 0.25, xp1: 0, yp1: 60, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section05_img_03', dt: 6, op1: 0.25, xp1: '-100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section05_img_02', dt: 6, op1: 0, xp1: 0, yp1: 10, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section05_img_01', dt: 6, op1: 0, xp1: 0, yp1: 20, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section05', '.section05', '100%', 0, twline, controller)
  twline = [
    { name: '.section06_text_01', dt: 5, op1: 0.5, xp1: 0, yp1: 50, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section06_img_01', dt: 5, op1: 0.25, xp1: '100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section06', '.section06', '100%', 0.1, twline, controller)
  twline = [
    { name: '.section07_text_01', dt: 5, op1: 0.5, xp1: 0, yp1: 50, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section07_img_03', dt: 5, op1: 0.25, xp1: 0, yp1: 100, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section07_img_01', dt: 5, op1: 0, xp1: 0, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section07', '.section07', '100%', 0.3, twline, controller)
  twline = [
    { name: '.section07b_text_01', dt: 5, op1: 0.5, xp1: 0, yp1: 50, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section07b_img_01', dt: 5, op1: 0, xp1: 0, sc1: 2, yp1: 30, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
  ]
  SectionAnimation('.section07b', '.section07b', '100%', 0.3, twline, controller)
  twline = [
    { name: '.sectionar_text', dt: 5, op1: 0.5, xp1: 0, yp1: 30, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
    { name: '.sectionar_img_01', dt: 10, op1: 0, xp1: 0, yp1: 100, sc1: 1, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
    { name: '.sectionar_img_02', dt: 10, op1: 0, xp1: 0, yp1: 20, sc1: 0, op2: 1, xp2: 0, yp2: 0, sc2: 1 },
  ]
  SectionAnimation('.sectionar', '.sectionar', '100%', 0, twline, controller)
}

function duxPlus(controller){

  let triggerHook = 0;
  if(navigator.userAgent.includes("Mac") && "ontouchend" in document){

    triggerHook = 0.6;
  }

  if(!isMobile2){
    //-- showCaseImageIntro
    const SceneOptions_showCaseImageIntro = {triggerElement: ".showcase-img", duration: "100%", triggerHook: triggerHook};
    const showCaseImageIntro_tween = TweenMax.fromTo(".showcase-img", 0.5,{ opacity: 0, xPercent: '-15%' },{ opacity: 1, xPercent: '0%' });    
    const showCaseImageIntro_indicator = { name: "showCaseImageIntro" };
    setAnimation(SceneOptions_showCaseImageIntro, showCaseImageIntro_tween, controller, showCaseImageIntro_indicator);

    //-- showCaseImage
    const SceneOptions_showCaseImage = {triggerElement: ".showcase-img", duration: 400, triggerHook: triggerHook, reverse: true,offset: 100};
    const showCaseImage_tween = TweenMax.fromTo(".showcase-img", 0.5,{ yPercent: '0%' }, { yPercent: '-15%' });    
    const showCaseImage_indicator = { name: "showCaseImage" };
    setAnimation(SceneOptions_showCaseImage, showCaseImage_tween, controller, showCaseImage_indicator);
  }
    
    
    //-- droppedAboveBeyond
    const SceneOptions_droppedAboveBeyond = {triggerElement: ".section02", duration: 600, triggerHook: triggerHook, reverse: true,}; //0.5
    const droppedAboveBeyond_tween = new TimelineMax()
    .fromTo('.section02_img_01', 150, { yPercent: -10 }, { yPercent: 0 })
    .fromTo('.section03_text_01', 150, { yPercent: -60 }, { yPercent: 0 })
    .fromTo('.section03_text_02', 150, { yPercent: -40 }, { yPercent: 0 })
    .fromTo('.section03_text_03', 150, { yPercent: -20 }, { yPercent: 0 })
    const droppedAboveBeyond_indicator = { name: "droppedAboveBeyond" };
    setAnimation(SceneOptions_droppedAboveBeyond, droppedAboveBeyond_tween, controller, droppedAboveBeyond_indicator);

    //-- deviceColors
    const SceneOptions_deviceColors = {triggerElement: ".section04", duration: 400, triggerHook: triggerHook, reverse: true,}; //0.5
    const deviceColors_tween = TweenMax.fromTo('.section04_img_01', 400,{ opacity: 0, xPercent: '100%' },{ opacity: 1, xPercent: 0 });    
    const deviceColors_indicator = { name: "deviceColors" };
    setAnimation(SceneOptions_deviceColors, deviceColors_tween, controller, deviceColors_indicator);

    //-- keepItSafe
    const SceneOptions_keepItSafe = {triggerElement: ".section05", duration: 400, triggerHook: triggerHook, reverse: true,}; //0.5
    const keepItSafe_tween = new TimelineMax()
    .fromTo('.section05_img_03', 200, { xPercent: -100 }, { xPercent: 0 })
    .fromTo('.section05_img_02', 200, { opacity: 0, scale: 2}, { opacity: 1, scale: 1 })
    const keepItSafe_indicator = { name: "keepItSafe" };
    setAnimation(SceneOptions_keepItSafe, keepItSafe_tween, controller, keepItSafe_indicator);

    //-- lifesaver
    const SceneOptions_lifesaver = {triggerElement: ".section06", duration: 400, triggerHook: triggerHook, reverse: true,}; //0.5
    const lifesaver_tween = TweenMax.fromTo('.section06_img_01', 400, {xPercent: '100%', opacity: 0.25 },{ xPercent: 0, opacity: 1 });    
    const lifesaver_indicator = { name: "lifesaver" };
    setAnimation(SceneOptions_lifesaver, lifesaver_tween, controller, lifesaver_indicator);
}

function duxShell(controller){
  let triggerHook = 0;
  if(navigator.userAgent.includes("Mac") && "ontouchend" in document){
    triggerHook = 0.5;
  }
  videoController( 3000, 1.2, controller);
  //-- showCaseImageIntro
  //-- const SceneOptions_showCaseImageIntro = {triggerElement: ".showcase-img", duration: "100%", triggerHook: triggerHook};
  //-- const showCaseImageIntro_tween = TweenMax.fromTo(".showcase-img", 0.5,{ opacity: 0, xPercent: -15 },{ opacity: 1, xPercent: 0 });    
  //-- const showCaseImageIntro_indicator = { name: "showCaseImageIntro" };
  //-- setAnimation(SceneOptions_showCaseImageIntro, showCaseImageIntro_tween, controller, showCaseImageIntro_indicator);

  //-- showCaseImage
  //-- const SceneOptions_showCaseImage = {triggerElement: ".showcase-img", duration: 400, triggerHook: triggerHook, reverse: true,offset: 100};
  //-- const showCaseImage_tween = TweenMax.fromTo(".showcase-img", 0.5,{ yPercent: 0 }, { yPercent: -15 });    
  //-- const showCaseImage_indicator = { name: "showCaseImage" };
  //-- setAnimation(SceneOptions_showCaseImage, showCaseImage_tween, controller, showCaseImage_indicator);

  //-- maximumProtection
  const SceneOptions_maximumProtection = {triggerElement: ".section02", duration: 400, triggerHook: triggerHook, reverse: true,};
  const maximumProtection_tween = new TimelineMax()
  .fromTo('.section02_img_01', 150, { yPercent: -10 }, { yPercent: 0 })
  .fromTo('.section03_text_01', 150, { yPercent: -60 }, { yPercent: 0 })
  .fromTo('.section03_text_02', 150, { yPercent: -40 }, { yPercent: 0 })
  .fromTo('.section03_text_03', 150, { yPercent: -20 }, { yPercent: 0 })
  const maximumProtection_indicator = { name: "maximumProtection" };
  setAnimation(SceneOptions_maximumProtection, maximumProtection_tween, controller, maximumProtection_indicator);

  //-- device
  const SceneOptions_device = {triggerElement: ".section04", duration: 400, triggerHook: triggerHook, reverse: true};
  const device_tween = TweenMax.fromTo('.section04_img_01',400,{opacity:0,xPercent:100},{opacity:1,xPercent:0});
  const device_indicator = { name: "device" };
  setAnimation(SceneOptions_device, device_tween, controller, device_indicator);

  //-- surfacePen
  const SceneOptions_surfacePen = {triggerElement: ".section05", duration: 400, triggerHook: triggerHook, reverse: true,};
  const surfacePen_tween = new TimelineMax()
  .fromTo('.section05_img_03', 200, { xPercent: -100 }, { xPercent: 0 })
  .fromTo('.section05_img_02', 200, { opacity: 0, scale: 2 }, { opacity: 1, scale: 1 })
  const surfacePen_indicator = { name: "surfacePen" };
  setAnimation(SceneOptions_surfacePen, surfacePen_tween, controller, surfacePen_indicator);

  //-- perfectViewing
  const SceneOptions_perfectViewing = {triggerElement: ".section06", duration: 400, triggerHook: triggerHook, reverse: true};
  const perfectViewing_tween = TweenMax.fromTo('.section06_img_01', 400, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 });   
  const perfectViewing_indicator = { name: "perfectViewing" };
  setAnimation(SceneOptions_perfectViewing, perfectViewing_tween, controller, perfectViewing_indicator);
}

function DuxBackpack30l(controller){
    controller.addScene(
        new ScrollMagic.Scene().setTween(new TimelineMax().fromTo(document.querySelector('.showcase-img'), 0.5, { opacity: 0, xPercent: -15 },{ opacity: 1, xPercent: 0 }))
    )

    const SECTIONS = document.querySelectorAll('[data-animation]');

  let triggerHook = 0;
  if(isMobile2()){
    triggerHook = 0.75;
  }
  if(navigator.userAgent.includes("Mac") && "ontouchend" in document){
    triggerHook = 0.6;
  }
    const animations = {
        duxBackpack: ({ triggerElement }) => {
            return new ScrollMagic.Scene(
            {triggerElement, duration: 600, triggerHook: triggerHook, reverse: true,}
            ).setTween(
            new TimelineMax().fromTo('.row', 10, { opacity: 0 }, { opacity: 1 })
            )
        },

        cleverlyconvinient: ({ triggerElement }) => {
            return new ScrollMagic.Scene(
            {triggerElement, duration: 600, triggerHook: triggerHook, reverse: true,}
            ).setTween(
            new TimelineMax().fromTo(triggerElement.querySelector('img'),10,{ opacity: 0, xPercent: -100},{ opacity: 1, xPercent: 0})
            )
        },

        boldlyunique: ({ triggerElement }) => {
            return new ScrollMagic.Scene(
            {triggerElement, duration: 600, triggerHook: triggerHook, reverse: true,}
            ).setTween(
            new TimelineMax()
                .fromTo(triggerElement.querySelectorAll('img')[0],10,{ opacity: 0, xPercent: 100 },{ opacity: 1, xPercent: 0 })
                .fromTo(triggerElement.querySelectorAll('img')[1],10,{ opacity: 0, scale: 1.5 },{ opacity: 1, scale: 1 })
            )
        },

        easystash: ({ triggerElement }) => {
            return new ScrollMagic.Scene(
            {triggerElement,duration: 600,triggerHook: triggerHook,reverse: true,}
            ).setTween(
            new TimelineMax().fromTo(
                triggerElement.querySelector('img'),10,{ opacity: 0, xPercent: -100 },{ opacity: 1, xPercent: 0 }
            )
            )
        },

        smarterbackpack: ({ triggerElement }) => {
          if (navigator.userAgent.includes("Mac") && "ontouchend" in document){
            return new ScrollMagic.Scene(
            {triggerElement, duration: 600, triggerHook: 0.6, reverse: true,}
            ).setTween(
            new TimelineMax()
                .fromTo('#divTxt1GridBackpack1', 10, { opacity: 0 }, { opacity: 1 })
                .fromTo(triggerElement.querySelectorAll('.imgAbsGridBackpack')[0], 10, { opacity: 0 }, { opacity: 1 })
                .fromTo('#divTxt2GridBackpack1', 10, { opacity: 0 }, { opacity: 1 })
                .fromTo(triggerElement.querySelectorAll('.imgAbsGridBackpack')[1], 10, { opacity: 0 }, { opacity: 1 })
                .fromTo('#divTxt3GridBackpack1', 10, { opacity: 0 }, { opacity: 1 })
                .fromTo(triggerElement.querySelectorAll('.imgAbsGridBackpack')[2], 10, { opacity: 0 }, { opacity: 1 })
                .fromTo('#divTxt4GridBackpack1', 10, { opacity: 0 }, { opacity: 1 })
                .fromTo(triggerElement.querySelectorAll('.imgAbsGridBackpack')[3], 10, { opacity: 0 }, { opacity: 1 })
                .fromTo(triggerElement.querySelector('.section03_img_003'), 10, { opacity: 0, scale: 1.5 }, { opacity: 1, scale: 1 })
            )
          }
          else{
            if(isMobile2()){return}
          
          var t = triggerElement.querySelector("h2"),
            e = triggerElement.querySelector("p"),
            n = triggerElement.querySelector(".imgGridBackpack1"),
            r = triggerElement.querySelector("#divGridDuxBackpack1 h3"),
            i = triggerElement.querySelector("#divGridDuxBackpack1 p"),
            o = triggerElement.querySelectorAll(".section03_img_002")[0],
            a = triggerElement.querySelector("#divTxt2GridBackpack1 h3"),
            u = triggerElement.querySelector("#divTxt2GridBackpack1 p"),
            s = triggerElement.querySelectorAll(".section03_img_002")[1],
            c = triggerElement.querySelector("#divTxt3GridBackpack1 h3"),
            l = triggerElement.querySelector("#divTxt3GridBackpack1 p"),
            f = triggerElement.querySelectorAll(".section03_img_002")[2],
            p = triggerElement.querySelector("#divTxt4GridBackpack1 h3"),
            h = triggerElement.querySelector("#divTxt4GridBackpack1 p"),
            d = triggerElement.querySelector(".section03_img_003"),
            g = triggerElement.querySelectorAll(".section03_img_002")[3];

            gsap.timeline().add(gsap.timeline({
                scrollTrigger: {
                    trigger: triggerElement,
                    pin: !0,
                    scrub: 1,
                    start: "top top",
                    end: "+=100%"
                }
            }).from([r, i, o], {
                opacity: 0,
                stagger: 1
            }).from([a, u, s], {
                opacity: 0,
                stagger: 1
            }).fromTo(n, {}, {
                duration: 1
            })).add(gsap.timeline({
                scrollTrigger: {
                    trigger: triggerElement,
                    pin: !0,
                    scrub: 1,
                    start: "bottom bottom",
                    end: "+=100%"
                }
            }).from([c, l, f], {
                opacity: 0,
                stagger: 1
            }).from([d, g, p, h], {
                opacity: 0,
                stagger: 1
            }).fromTo(n, {}, {
                duration: 1
            }))
          }
          
          
        },

        quickaccess: ({ triggerElement }) => {
            return new ScrollMagic.Scene(
            {triggerElement, duration: 600, triggerHook: triggerHook, reverse: true,}
            ).setTween(
            new TimelineMax().fromTo(
                triggerElement.querySelector('img'),10,{ opacity: 0, xPercent: -100 },{ opacity: 1, xPercent: 0 }
            )
            )
        },

        multiplepockets: ({ triggerElement }) => {
            return new ScrollMagic.Scene({
            triggerElement,duration: '100%',duration: 600,triggerHook: triggerHook,reverse: true,
            }).setTween(
            new TimelineMax().fromTo(
                triggerElement.querySelector('img'),10,{ opacity: 0, xPercent: 100 },{ opacity: 1, xPercent: 0 }
            )
            )
        },

        passport: ({ triggerElement }) => {
            return new ScrollMagic.Scene(
            {triggerElement,duration: '100%',duration: 600,triggerHook: triggerHook,reverse: true,}
            ).setTween(
            new TimelineMax()
                .fromTo(
                [ triggerElement.querySelectorAll('img')[1],
                    triggerElement.querySelectorAll('img')[3],
                    triggerElement.querySelectorAll('img')[4],
                ], 10,{ yPercent: -100 }, { yPercent: 0 }
                )
                .fromTo(triggerElement.querySelector('#divTxt2GridBackpack2'), 5, { opacity: 0 }, { opacity: 1 })
                .fromTo(triggerElement.querySelectorAll('.section03_img_002')[1], 5, { opacity: 0 }, { opacity: 1 })
                .fromTo(triggerElement.querySelectorAll('img')[4], 5, { opacity: 1 }, { opacity: 0.5 })
                .fromTo(triggerElement.querySelector('#divTxt1GridBackpack2'), 5, { opacity: 0 }, { opacity: 1 })
                .fromTo(triggerElement.querySelectorAll('.section03_img_002')[0], 5, { opacity: 0 }, { opacity: 1 })
            )
        },

        colors: ({ triggerElement }) => {
            return new ScrollMagic.Scene(
            { triggerElement, duration: 600, triggerHook: triggerHook, reverse: true }
            ).setTween(
            new TimelineMax().fromTo(
                triggerElement.querySelector('.carousel'),10,{ opacity: 0, xPercent: -100 },{ opacity: 1, xPercent: 0 }
            )
            )
        },
    }

    SECTIONS.forEach(section => {
      if(animations[section.getAttribute('data-animation')] !== undefined){
         controller.addScene(animations[section.getAttribute('data-animation')]({ triggerElement: section }))
      }
       
    });
}

function myth18L(controller){
  if(isMobile2()){return}
  let triggerhook = 0;
  if(navigator.userAgent.includes("Mac") && "ontouchend" in document){
    triggerhook = 0.6;
  }
    //-- showCaseImageIntro
    const SceneOptions_showCaseImageIntro = {triggerElement: ".showcase-img", duration: "100%", triggerHook: triggerhook};
    const showCaseImageIntro_tween = TweenMax.fromTo(".showcase-img", 0.5,{ opacity: 0, xPercent: '-15%' },{ opacity: 1, xPercent: '0%' });    
    const showCaseImageIntro_indicator = { name: "showCaseImageIntro" };
    setAnimation(SceneOptions_showCaseImageIntro, showCaseImageIntro_tween, controller, showCaseImageIntro_indicator);

    //-- showCaseImage
    const SceneOptions_showCaseImage = {triggerElement: ".showcase-img", duration: 400, triggerHook: triggerhook, reverse: true, offset: 100};
    const showCaseImage_tween = TweenMax.fromTo(".showcase-img", 0.5,{ yPercent: '0%' }, { yPercent: '-15%' });    
    const showCaseImage_indicator = { name: "showCaseImage" };
    setAnimation(SceneOptions_showCaseImage, showCaseImage_tween, controller, showCaseImage_indicator);

    //-- illuminating
    const SceneOptions_illuminating = {triggerElement: ".section02", duration: 600, triggerHook: triggerhook, reverse: true,};
    const illuminating_tween = new TimelineMax()
    .fromTo('.section02_img_003', 200, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
    .fromTo('.section02_img_001', 200, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
    const illuminating_indicator = { name: "illuminating" };
    setAnimation(SceneOptions_illuminating, illuminating_tween, controller, illuminating_indicator);

    //-- looks
    const SceneOptions_looks = {triggerElement: ".section03",  duration: 450, triggerHook: triggerhook, reverse: true,};
    const looks_tween = new TimelineMax()
    .fromTo('.section03_img_001', 50, { opacity: 0, yPercent: 20 }, { opacity: 1, yPercent: 0 })
    .fromTo('.section03_text_04', 50, { opacity: 0 }, { opacity: 1 })
    .fromTo('.section03_img_002', 50, { opacity: 0 }, { opacity: 1 })
    .fromTo('.section03_text_05', 50, { opacity: 0 }, { opacity: 1 })
    .fromTo('.section03_img_003', 50, { opacity: 0 }, { opacity: 1 })
    .fromTo('.section03_text_06', 50, { opacity: 0 }, { opacity: 1 })
    .fromTo('.section03_img_005', 50, { opacity: 0 }, { opacity: 1 })
    .fromTo('.section03_img_004', 50, { opacity: 0 }, { opacity: 1 })
    .fromTo('.section03_text_07', 50, { opacity: 0 }, { opacity: 1 })
    const looks_indicator = { name: "looks" };
    setAnimation(SceneOptions_looks, looks_tween, controller, looks_indicator);

    //-- colors
    const SceneOptions_colors = {triggerElement: ".section04",  duration: 400, triggerHook: triggerhook, reverse: true,};
    const colors_tween = new TimelineMax()
    .fromTo('.section04_text_01', 200, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('.section04_img_02', 200, { opacity: 0, scale: 0.5, yPercent: 5 }, { opacity: 1, scale: 1, yPercent: 0 })
    const colors_indicator = { name: "colors" };
    setAnimation(SceneOptions_colors, colors_tween, controller, colors_indicator);
}

function duxPlusDuo(controller){
  if(isMobile2()){return}
  if (navigator.userAgent.includes("Mac") && "ontouchend" in document){
    const ipadIMG = document.querySelector(".imgTopCortada").style.zIndex = "-1";
    let twline = []
  twline = [
    { name: '.section02_img_01', dt: 10, op1: 1, xp1: 0, yp1: -10, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section03_text_01', dt: 5, op1: 1, xp1: 0, yp1: -60, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section03_text_02', dt: 5, op1: 1, xp1: 0, yp1: -50, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section03_text_03', dt: 5, op1: 1, xp1: 0, yp1: -40, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('', '.section02', '100%', 0.6, twline, controller)
  twline = [
    { name: '.section04_img_01', dt: 5, op1: 0.25, xp1: '100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04_img_02', dt: 10, op1: 1, xp1: 0, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('', '.section04', '100%', 0.6, twline, controller)
  twline = [
    { name: '.section04B_img_01', dt: 6, op1: 0, xp1: -150, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04B_img_02', dt: 6, op1: 0, xp1: 150, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('', '.section04B', '100%', 1, twline, controller)
  twline = [
    { name: '.section05_img_03', dt: 6, op1: 0.25, xp1: '-100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section05_img_02', dt: 6, op1: 0, xp1: 0, yp1: 10, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section05_img_01', dt: 6, op1: 0, xp1: 0, yp1: 20, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('', '.section05', '100%', 0.6, twline, controller)
  twline = [{ name: '.section06_img_01', dt: 5, op1: 0.25, xp1: '100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 }]
  
  SectionAnimation('', '.section06', '100%', 0.6, twline, controller)
  }
  else{
   let twline = []
  twline = [
    { name: '.section02_img_01', dt: 10, op1: 1, xp1: 0, yp1: -10, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section03_text_01', dt: 5, op1: 1, xp1: 0, yp1: -60, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section03_text_02', dt: 5, op1: 1, xp1: 0, yp1: -50, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section03_text_03', dt: 5, op1: 1, xp1: 0, yp1: -40, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section02', '.section02', '100%', 0, twline, controller)
  twline = [
    { name: '.section04_img_01', dt: 5, op1: 0.25, xp1: '100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04_img_02', dt: 10, op1: 1, xp1: 0, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section04', '.section04', '100%', 0, twline, controller)
  twline = [
    { name: '.section04B_img_01', dt: 6, op1: 0, xp1: -150, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section04B_img_02', dt: 6, op1: 0, xp1: 150, yp1: 0, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section04B', '.section04B', '100%', 0, twline, controller)
  twline = [
    { name: '.section05_img_03', dt: 6, op1: 0.25, xp1: '-100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section05_img_02', dt: 6, op1: 0, xp1: 0, yp1: 10, op2: 1, xp2: 0, yp2: 0 },
    { name: '.section05_img_01', dt: 6, op1: 0, xp1: 0, yp1: 20, op2: 1, xp2: 0, yp2: 0 },
  ]
  SectionAnimation('.section05', '.section05', '100%', 0, twline, controller)
  twline = [{ name: '.section06_img_01', dt: 5, op1: 0.25, xp1: '100%', yp1: 0, op2: 1, xp2: 0, yp2: 0 }]
  
  SectionAnimation('.section06', '.section06', '100%', 0.2, twline, controller) 
  }
}
function duxKeyboard(controller){
  let triggerhook = 0;
  let triggerhook2 = 0.7;
  let triggerhook3 = 0;
  let durattion = "100%";
  let durattion2 = "50%";
  let durattion3 = "100%";
  if(navigator.userAgent.includes("Mac") && "ontouchend" in document || isMobile2()){
    triggerhook = 0.6;
    triggerhook2 = 0.9
    triggerhook3 = 0.5;
    durattion = "50%"
    durattion2 = "30%";
    durattion3 = "30%";
  }
    // Dux Keyboard
    const SceneOptions_duxKeyboard = {triggerElement: "#title_overview", duration: 300, triggerHook: 0.5, reverse: true,};
    const duxKeyboard_tween = new TimelineMax()
    .fromTo('#title_overview', 100, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('#subtitle_overview', 100, { yPercent: 100 }, { yPercent: 0 })
    .fromTo('#content_overview', 100, { yPercent: 40 }, { yPercent: 0 })
    const duxKeyboard_indicator = { name: "duxKeyboard" };
    setAnimation(SceneOptions_duxKeyboard, duxKeyboard_tween, controller, duxKeyboard_indicator);

    // The ruggedised Dux
    const SceneOptions_TheRuggedisedDux_R = {triggerElement: "#theRuggedisedDux", duration: durattion, triggerHook: triggerhook, reverse: true,};
    const TheRuggedisedDux_R_tween = new TimelineMax()
    .fromTo('#title_ruggedised_R', 100, { xPercent: -150, opacity: 0 }, { xPercent: 0, opacity: 1 })
    .fromTo('#subtitle_ruggedised_R', 100, { xPercent: -150, opacity: 0 }, { xPercent: 0, opacity: 1 })
    .fromTo('#content_ruggedised_R', 100, { xPercent: -150, opacity: 0 }, { xPercent: 0, opacity: 1 })
    .fromTo('#img_ruggedised_03_R', 100, { opacity: 0 }, { opacity: 1 })
    .fromTo('#img_ruggedised_02_R', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_ruggedised_01_R', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    const TheRuggedisedDux_R_indicator = { name: "TheRuggedisedDux" };
    setAnimation(SceneOptions_TheRuggedisedDux_R, TheRuggedisedDux_R_tween, controller, TheRuggedisedDux_R_indicator);

    // The ruggedised Dux Responsive
    const SceneOptions_TheRuggedisedDux = {triggerElement: "#theRuggedisedDux", duration: durattion, triggerHook: triggerhook, reverse: true,};
    const TheRuggedisedDux_tween = new TimelineMax()
    .fromTo('#title_ruggedised', 100, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('#subtitle_ruggedised', 100, { yPercent: 100 }, { yPercent: 0 })
    .fromTo('#content_ruggedised', 100, { yPercent: 40 }, { yPercent: 0 })
    .fromTo('#img_ruggedised_03', 100, { opacity: 0 }, { opacity: 1 })
    .fromTo('#img_ruggedised_02', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_ruggedised_01', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    const TheRuggedisedDux_indicator = { name: "TheRuggedisedDux" };
    setAnimation(SceneOptions_TheRuggedisedDux, TheRuggedisedDux_tween, controller, TheRuggedisedDux_indicator);

    // Innovative Hinged
    const SceneOptions_InnovativeHinged = {triggerElement: "#innovative", duration: 300, triggerHook: 0.5, reverse: true,};
    const InnovativeHinged_tween = new TimelineMax()
    .fromTo('#title_innovative', 100, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('#subtitle_innovative', 100, { yPercent: 100 }, { yPercent: 0 })
    .fromTo('#content_innovative', 100, { yPercent: 40 }, { yPercent: 0 })
    const InnovativeHinged_indicator = { name: "InnovativeHinged" };
    setAnimation(SceneOptions_InnovativeHinged, InnovativeHinged_tween, controller, InnovativeHinged_indicator);

    // Rugged protection circle
    const SceneOptions_protectionCircle = {triggerElement: "#div_down_circle", duration: durattion2, triggerHook: triggerhook2, reverse: true,};
    const protectionCircle_tween = TweenMax.fromTo("#div_down_circle", 1, { borderRadius: "0, 0, 0, 0"}, { borderRadius: "0, 0, 60%, 60%", ease: Linear.easeNone });
    const protectionCircle_indicator = { name: "protection_circle" };
    setAnimation(SceneOptions_protectionCircle, protectionCircle_tween, controller, protectionCircle_indicator);

    // img Circle
    const SceneOptions_img_circle = {triggerElement: "#imgCircle", duration: durattion2, triggerHook: triggerhook2, reverse: true,};
    const img_circle_tween = new TimelineMax()
    .fromTo('#img_circle', 100, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
    const img_circle_indicator = { name: "img_circle" };
    setAnimation(SceneOptions_img_circle, img_circle_tween, controller, img_circle_indicator);

    // Infinity Stand
    const SceneOptions_InfinityStand = {triggerElement: "#InfinityStand", duration: durattion, triggerHook: triggerhook, reverse: true,};
    const InfinityStand_tween = new TimelineMax()
    .fromTo('#title_infinityStand', 100, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('#subtitle_infinityStand', 100, { yPercent: 100 }, { yPercent: 0 })
    .fromTo('#content_infinityStand', 100, { yPercent: 40 }, { yPercent: 0 })
    // .fromTo('#img_infinityStand', 100, { opacity: 0, xPercent: "-100%" }, { opacity: 1, xPercent: 0 })
    const InfinityStand_indicator = { name: "InfinityStand" };
    setAnimation(SceneOptions_InfinityStand, InfinityStand_tween, controller, InfinityStand_indicator);

    // Infinity Stand
    const SceneOptions_InfinityStand_R = {triggerElement: "#InfinityStand", duration: "30%", triggerHook: triggerhook, reverse: true,};
    const InfinityStand_R_tween = new TimelineMax()
    .fromTo('#title_infinityStand_R', 100, { xPercent: 150, opacity: 0 }, { xPercent: 0, opacity: 1 })
    .fromTo('#subtitle_infinityStand_R', 100, { xPercent: 150, opacity: 0 }, { xPercent: 0, opacity: 1 })
    .fromTo('#content_infinityStand_R', 100, { xPercent: 150, opacity: 0 }, { xPercent: 0, opacity: 1 })
    // .fromTo('#img_infinityStand_R', 100, { opacity: 0, xPercent: "-100%" }, { opacity: 1, xPercent: 0 })
    const InfinityStand_R_indicator = { name: "InfinityStand_R" };
    setAnimation(SceneOptions_InfinityStand_R, InfinityStand_R_tween, controller, InfinityStand_R_indicator);

    // Infinity Stand sequence
    const sceneOptions_InfinityStand_sec = { triggerElement: "#InfinityStand", triggerHook: triggerhook3, duration: durattion3 };
     let imagesInfinityStand = [
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_001.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_002.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_003.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_004.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_005.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_006.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_007.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_008.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_009.png",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_04_v001_010.png",
     ];
     let objInfinityStand = { curImg: 0 };
     const tween_InfinityStand_sec = TweenMax.to(objInfinityStand, 1, {
         curImg: imagesInfinityStand.length - 1,
         roundProps: "curImg",
         immediateRender: true,
         ease: Linear.easeNone,
         onUpdate: function () {
            document.getElementById("img_infinityStand").src = imagesInfinityStand[objInfinityStand.curImg];
         }
     });
     const indicatorOptions_InfinityStand_sec = { name: "InfinityStand_img" };
     setAnimation(sceneOptions_InfinityStand_sec, tween_InfinityStand_sec, controller, indicatorOptions_InfinityStand_sec);

    // Store Charge
    const SceneOptions_StoreCharge = {triggerElement: "#StoreCharge", duration: durattion, triggerHook: triggerhook, reverse: true,};
    const StoreCharge_tween = new TimelineMax()
    .fromTo('#title_storeCharge', 100, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('#subtitle_storeCharge', 100, { yPercent: 100 }, { yPercent: 0 })
    .fromTo('#content_storeCharge', 100, { yPercent: 40 }, { yPercent: 0 })
    .fromTo('#img_storeCharge_01', 100, {opacity: 0, yPercent: 40 }, {opacity: 1, yPercent: 0 })
    .fromTo('#img_storeCharge_02', 100, {opacity: 0,  }, {opacity: 1,  })
    .fromTo('#img_storeCharge_04', 100, {opacity: 0, yPercent: 40 }, {opacity: 1, yPercent: 0 })
    .fromTo('#img_storeCharge_03', 100, {opacity: 0, yPercent: 40 }, {opacity: 1, yPercent: 0 })
    const StoreCharge_indicator = { name: "StoreCharge" };
    setAnimation(SceneOptions_StoreCharge, StoreCharge_tween, controller, StoreCharge_indicator);

    // Full keyboard
    const SceneOptions_fullKeyboard = {triggerElement: "#Fullkeyboard", duration: durattion, triggerHook: triggerhook, reverse: true,};
    const fullKeyboard_tween = new TimelineMax()
    .fromTo('#title_fullKeyboard', 100, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('#subtitle_fullKeyboard', 100, { yPercent: 100 }, { yPercent: 0 })
    .fromTo('#content_fullKeyboard', 100, { yPercent: 40 }, { yPercent: 0 })
    // .fromTo('#img_fullKeyboard_01', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    // .fromTo('#img_fullKeyboard_02', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })

    const fullKeyboard_indicator = { name: "fullKeyboard" };
    setAnimation(SceneOptions_fullKeyboard, fullKeyboard_tween, controller, fullKeyboard_indicator);

    // Full keyboard
    const SceneOptions_fullKeyboard_R = {triggerElement: "#Fullkeyboard", duration: "30%", triggerHook: triggerhook, reverse: true,};
    const fullKeyboard_R_tween = new TimelineMax()
    .fromTo('#title_fullKeyboard_R', 100, { xPercent: -150, opacity: 0 }, { xPercent: 0, opacity: 1 })
    .fromTo('#subtitle_fullKeyboard_R', 100, { xPercent: -150, opacity: 0 }, { xPercent: 0, opacity: 1 })
    .fromTo('#content_fullKeyboard_R', 100, { xPercent: -150, opacity: 0 }, { xPercent: 0, opacity: 1 })

    const fullKeyboard_R_indicator = { name: "fullKeyboard_R" };
    setAnimation(SceneOptions_fullKeyboard_R, fullKeyboard_R_tween, controller, fullKeyboard_R_indicator);

    const sceneOptions_Full_keyboard_sec = { triggerElement: "#Fullkeyboard", triggerHook: triggerhook3, duration: durattion3 };
     let imagesFull_keyboard = [
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_000.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_001.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_002.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_003.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_004.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_005.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_006.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_007.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_008.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_009.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_010.jpg",

     ];
     let objFull_keyboard = { curImg: 0 };
     const tween_Full_keyboard_sec = TweenMax.to(objFull_keyboard, 1, {
         curImg: imagesFull_keyboard.length - 1,
         roundProps: "curImg",
         immediateRender: true,
         ease: Linear.easeNone,
         onUpdate: function () {
            document.getElementById("img_fullKeyboard_01").src = imagesFull_keyboard[objFull_keyboard.curImg];
         }
     });
     const indicatorOptions_Full_keyboard_sec = { name: "Full_keyboard_img" };
     setAnimation(sceneOptions_Full_keyboard_sec, tween_Full_keyboard_sec, controller, indicatorOptions_Full_keyboard_sec);

     const sceneOptions_Full_keyboard_Responsive_sec = { triggerElement: "#Fullkeyboard", triggerHook: 0.3, duration: "30%" };
     let imagesFull_keyboard_Responsive = [
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_000_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_001_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_002_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_003_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_004_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_005_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_006_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_007_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_008_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_009_Responsive.jpg",
         "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_KEYBOARD_06_v002_010_Responsive.jpg",

     ];
     let objFull_keyboard_Responsive = { curImg: 0 };
     const tween_Full_keyboard_Responsive_sec = TweenMax.to(objFull_keyboard_Responsive, 1, {
         curImg: imagesFull_keyboard_Responsive.length - 1,
         roundProps: "curImg",
         immediateRender: true,
         ease: Linear.easeNone,
         onUpdate: function () {
            document.getElementById("img_fullKeyboard_01_R").src = imagesFull_keyboard_Responsive[objFull_keyboard_Responsive.curImg];
         }
     });
     const indicatorOptions_Full_keyboard_Responsive_sec = { name: "Full_keyboard_Responsive_img" };
     setAnimation(sceneOptions_Full_keyboard_Responsive_sec, tween_Full_keyboard_Responsive_sec, controller, indicatorOptions_Full_keyboard_Responsive_sec);


    
     // Ports
    const SceneOptions_portsReady = {triggerElement: "#ports", duration: durattion, triggerHook: triggerhook, reverse: true,};
    const portsReady_tween = new TimelineMax()
    .fromTo('#title_portsReady', 100, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('#subtitle_portsReady', 100, { yPercent: 100 }, { yPercent: 0 })
    .fromTo('#content_portsReady', 100, { yPercent: 40 }, { yPercent: 0 })
    .fromTo('#content_portsReady_note', 100, { yPercent: 60 }, { yPercent: 0 })
    .fromTo('#img_portsReady_01', 100, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_portsReady_02', 100, { opacity: 0,  }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_portsReady_03', 100, { opacity: 0,  }, { opacity: 1, xPercent: 0 })

    const portsReady_indicator = { name: "portsReady" };
    setAnimation(SceneOptions_portsReady, portsReady_tween, controller, portsReady_indicator);
    
}

function duxUltra(controller){
  let triggerhook = 0;
  if(isMobile2()){
    triggerhook = 0.75;
  }
  if (navigator.userAgent.includes("Mac") && "ontouchend" in document){
    triggerhook = 0.75;
  }
  //-- overview
  const SceneOptions_overview = {triggerElement: "#Overview",  duration: 400, triggerHook: 0.6, reverse: true,};
  const overview_tween = new TimelineMax()
  .fromTo('#title_overview', 200, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#subtitle_overview', 200, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#content_overview', 200, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  const overview_indicator = { name: "overview" };
  setAnimation(SceneOptions_overview, overview_tween, controller, overview_indicator);

  // dropProtection
  const SceneOptions_dropProtection = {triggerElement: "#dropProtectionUltra",  duration: 400, triggerHook:triggerhook, reverse: true,};
  const dropProtection_tween = new TimelineMax()
  // .fromTo('#description_dropProtection', 200, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
  .fromTo('#subtitle_dropProtection', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#text_dropProtection', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#img_dropProtection', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  const dropProtection_indicator = { name: "dropProtection" };
  setAnimation(SceneOptions_dropProtection, dropProtection_tween, controller, dropProtection_indicator);

  let triggerhook3 = triggerhook;
  if(isMobile2()){
    triggerhook3 = 0.55;
  }
  else{
    triggerhook3 = 0.4;
  }
  //-- easymag
  const SceneOptions_easymag = {triggerElement: "#easymag",  duration: 400, triggerHook: triggerhook3, reverse: true,};
  const easymag_tween = new TimelineMax()
  .fromTo('#title_easymag', 100, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#subtitle_easymag', 100, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#content_easymag', 100, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#img_easymag', 100, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  const easymag_indicator = { name: "easymag" };
  setAnimation(SceneOptions_easymag, easymag_tween, controller, easymag_indicator);

  
  // angles
  const SceneOptions_angles = {triggerElement: "#angles",  duration: 400, triggerHook: triggerhook, reverse: true,};
  const angles_tween = new TimelineMax()
  .fromTo('#description_angles', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
  .fromTo('#subtitle_angles', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#text_angles', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  // .fromTo('#img_angles', 200, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
  const angles_indicator = { name: "angles" };
  setAnimation(SceneOptions_angles, angles_tween, controller, angles_indicator);

  // angles_sequence
  let triggerhook2 = triggerhook;
  let duration = "100%"
  if(isMobile2()){
    triggerhook2 = 0.4;
    duration ="50%"
  }
  if (navigator.userAgent.includes("Mac") && "ontouchend" in document && !isMobile2()){
    triggerhook2 = 0.9;
  }
  const sceneOptionsangles_sequence = { triggerElement: "#angles", triggerHook: triggerhook2, duration: duration };
  let images = [
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_07.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_09.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_11.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_13.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_15.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_17.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_19.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_21.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_23.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_25.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_27.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_29.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_33.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_37.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_41.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_45.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_49.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_53.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_61.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_69.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_77.png",
    "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/STM_DUX_ULTRA_04_85.png",
  ];
  let obj = { curImg: 0 };
  const tweenangles_sequence = TweenMax.to(obj, 0.5, {
      curImg: images.length - 1,
      roundProps: "curImg",
      immediateRender: true,
      ease: Linear.easeNone,
      onUpdate: function () {
          document.getElementById("img_angles").srcset = images[obj.curImg];
      }
  });
  const indicatorOptionsangles_sequence = { name: "img_angles" };
  setAnimation(sceneOptionsangles_sequence, tweenangles_sequence, controller, indicatorOptionsangles_sequence);

  let triggerhookstore = 0;
  let durationstore = 900  
  if(isMobile2()){
    triggerhookstore = 0.4
    durationstore = "25%"
    // store and charge
    const SceneOptions_store = {triggerElement: "#store",  duration:durationstore, triggerHook: triggerhookstore, reverse: true,};
    const store_tween = new TimelineMax()
    // .fromTo('#description_store', 200, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_1', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_2', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_3', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_4', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    // .fromTo('#img_store_3', 200, {xPercent: 0 }, {xPercent: 18 })
    // .fromTo('#img_store_3', 200, {xPercent: 18 }, {xPercent: 0 })
    // .fromTo('#img_store_4', 200, {xPercent: 0 }, {xPercent: 28 })
    // .fromTo('#img_store_4', 200, {xPercent: 28 }, {xPercent: 0 })

    const store_indicator = { name: "store" };
    setAnimation(SceneOptions_store, store_tween, controller, store_indicator);
  }
  else if (navigator.userAgent.includes("Mac") && "ontouchend" in document && !isMobile2()){
    console.log("ipad")
    triggerhookstore = 0.6;
    // store and charge
    const SceneOptions_store = {triggerElement: "#store",  duration:"25%", triggerHook: triggerhookstore, reverse: true,};
    const store_tween = new TimelineMax()
    // .fromTo('#description_store', 200, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_1', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_2', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_3', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_4', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    // .fromTo('#img_store_3', 200, {xPercent: 0 }, {xPercent: 18 })
    // .fromTo('#img_store_3', 200, {xPercent: 18 }, {xPercent: 0 })
    // .fromTo('#img_store_4', 200, {xPercent: 0 }, {xPercent: 28 })
    // .fromTo('#img_store_4', 200, {xPercent: 28 }, {xPercent: 0 })
    const store_indicator = { name: "store" };
    setAnimation(SceneOptions_store, store_tween, controller, store_indicator);
  }
  else{
    // store and charge
    const SceneOptions_store = {triggerElement: "#store",  duration:900, triggerHook: 0, reverse: true,};
    const store_tween = new TimelineMax()
    // .fromTo('#description_store', 200, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#subtitle_store', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
    .fromTo('#text_store', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
    .fromTo('#img_store_1', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_2', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_3', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_4', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#img_store_3', 225, {xPercent: 0 }, {xPercent: 18 })
    .fromTo('#img_store_3', 225, {xPercent: 18 }, {xPercent: 0 })
    .fromTo('#img_store_4', 225, {xPercent: 0 }, {xPercent: 28 })
    .fromTo('#img_store_4', 225, {xPercent: 28 }, {xPercent: 0 })
  
    const store_indicator = { name: "store" };
    setAnimation(SceneOptions_store, store_tween, controller, store_indicator);
  }

  //-- full Button
  const SceneOptions_fullButton = {triggerElement: "#fullButton",  duration: 400, triggerHook:triggerhook, reverse: true,};
  const fullButton_tween = new TimelineMax()
  .fromTo('#title_fullButton', 100, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#subtitle_fullButton', 100, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#content_fullButton', 100, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#img_fullButton_1', 100, { opacity: 0, yPercent: 100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#img_fullButton_2', 100, { opacity: 0, scale: 0 }, { opacity: 1, scale: 1 })
  const fullButton_indicator = { name: "fullButton" };
  setAnimation(SceneOptions_fullButton, fullButton_tween, controller, fullButton_indicator);

  // Make it yours
  const SceneOptions_makeit = {triggerElement: "#makeit",  duration: 600, triggerHook: triggerhook, reverse: true,};
  const makeit_tween = new TimelineMax()
  // .fromTo('#description_makeit', 200, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#subtitle_makeit', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#text_makeit', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#img_makeit_2', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
  .fromTo('#img_makeit_3', 100, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })  
  const makeit_indicator = { name: "makeit" };
  setAnimation(SceneOptions_makeit, makeit_tween, controller, makeit_indicator);

  // Ports ready
  const SceneOptions_ports = {triggerElement: "#ports",  duration: 600, triggerHook: triggerhook, reverse: true,};
  const ports_tween = new TimelineMax()
  // .fromTo('#description_ports', 200, { opacity: 0, xPercent: 100 }, { opacity: 1, xPercent: 0 })
    .fromTo('#subtitle_ports', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#text_ports', 200, { opacity: 0, yPercent: -100 }, { opacity: 1, yPercent: 0 })
  .fromTo('#img_ports_1', 100, { opacity: 0, xPercent: -100 }, { opacity: 1, xPercent: 0 })
  .fromTo('#img_ports_2', 100, { opacity: 0, xPercent: -100, yPercent: 100 }, { opacity: 1, xPercent: 0, yPercent: 0 })  
  const ports_indicator = { name: "ports" };
  setAnimation(SceneOptions_ports, ports_tween, controller, ports_indicator);
}

function chargeTreeAir(controller){
    const SceneOptions_chargetreeair = {triggerElement: "#title_overview", duration: 300, triggerHook: 0.5, reverse: true,};
    const chargetreeair_tween = new TimelineMax()
    .fromTo('#title_overview', 100, { yPercent: 10 }, { yPercent: 0 })
    .fromTo('#subtitle_overview', 100, { yPercent: 100 }, { yPercent: 0 })
    .fromTo('#content_overview', 100, { yPercent: 40 }, { yPercent: 0 })
    const chargetreeair_indicator = { name: "chargetreeair" };
    setAnimation(SceneOptions_chargetreeair, chargetreeair_tween, controller, chargetreeair_indicator);


    const SceneOptions_smarterTexts = {triggerElement: "#smarter_features", duration: "100%", triggerHook: 0.5, reverse: true,};
    const smarterTexts_tween = new TimelineMax()
    .fromTo('#title_smarter_features', 100, { xPercent: -100, opacity:0 }, { xPercent: 0, opacity:1  })
    .fromTo('#subtitle_smarter_features', 100, { xPercent: -100, opacity:0  }, { xPercent: 0, opacity:1 })
    .fromTo('#content_smarter_features', 100, { xPercent: -100, opacity:0  }, { xPercent: 0, opacity:1 })
    const smarterTexts_indicator = { name: "smarterTexts" };
    setAnimation(SceneOptions_smarterTexts, smarterTexts_tween, controller, smarterTexts_indicator);

    // Smarter Features sequence
    const sceneOptions_smarterfeatures_sec = { triggerElement: "#smarter_features", triggerHook: 0, duration: "90%" };
     let smarterfeaturesSec = [
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_00.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_01.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_02.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_03.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_04.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_05.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_06.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_07.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_08.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_09.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_10.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_11.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_12.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_13.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_14.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_15.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_16.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_17.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_18.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_19.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_20.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_21.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_22.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_23.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_24.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_25.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_26.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_27.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_28.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_02_29.png",
     ];
     let objsmarterfeatures = { curImg: 0 };
     const tween_smarterfeatures_sec = TweenMax.to(objsmarterfeatures, 1, {
         curImg: smarterfeaturesSec.length - 1,
         roundProps: "curImg",
         immediateRender: true,
         ease: Linear.easeNone,
         onUpdate: function () {
            document.getElementById("img_smarter_features").src = smarterfeaturesSec[objsmarterfeatures.curImg];
         }
     });
     const indicatorOptions_smarterfeatures_sec = { name: "smarterfeatures_img" };
     setAnimation(sceneOptions_smarterfeatures_sec, tween_smarterfeatures_sec, controller, indicatorOptions_smarterfeatures_sec);

     // Smarter Features sequence
    const sceneOptions_independentCharging_sec = { triggerElement: "#Independent_charging", triggerHook: 0, duration: "100%" };
     let independentChargingSec = [
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_00.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_01.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_02.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_03.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_04.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_05.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_06.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_07.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_08.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_09.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_10.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_11.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_12.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_13.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_14.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_15.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_16.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_17.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_18.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_19.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_20.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_21.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_22.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_23.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_24.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_25.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_26_v2.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_27_v2.png",        
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_28_v2.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_29_v2.png",
     ];
     let objindependentCharging = { curImg: 0 };
     const tween_independentCharging_sec = TweenMax.to(objindependentCharging, 1, {
         curImg: independentChargingSec.length - 1,
         roundProps: "curImg",
         immediateRender: true,
         ease: Linear.easeNone,
         onUpdate: function () {
            document.getElementById("sec_chargetreeair").src = independentChargingSec[objindependentCharging.curImg];
         }
     });
     const indicatorOptions_independentCharging_sec = { name: "independentCharging_img" };
     setAnimation(sceneOptions_independentCharging_sec, tween_independentCharging_sec, controller, indicatorOptions_independentCharging_sec);

    // Rugged protection circle
    const SceneOptions_protectionCircle = {triggerElement: "#div_down_circle", duration: "50%", triggerHook: 0.7, reverse: true,};
    const protectionCircle_tween = TweenMax.fromTo("#div_down_circle", 1, { borderRadius: "0, 0, 0, 0"}, { borderRadius: "0, 0, 60%, 60%", ease: Linear.easeNone });
    const protectionCircle_indicator = { name: "protection_circle" };
    setAnimation(SceneOptions_protectionCircle, protectionCircle_tween, controller, protectionCircle_indicator);

    // Smarter Features sequence mobile
    const sceneOptions_independentCharging_mobile_sec = { triggerElement: "#Independent_charging_mobile", triggerHook: 0, duration: "100%" };
     let independentCharging_mobileSec = [
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_00.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_01.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_02.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_03.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_04.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_05.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_06.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_07.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_08.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_09.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_10.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_11.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_12.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_13.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_14.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_15.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_16.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_17.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_18.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_19.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_20.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_21.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_22.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_23.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_24.png",
        //"https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_25.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_26_v2.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_27_v2.png",        
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_28_v2.png",
        "https://cdn.shopify.com/s/files/1/0896/0062/2871/files/chargetree_air_03_29_v2.png",
     ];
     let objindependentCharging_mobile = { curImg: 0 };
     const tween_independentCharging_mobile_sec = TweenMax.to(objindependentCharging_mobile, 1, {
         curImg: independentCharging_mobileSec.length - 1,
         roundProps: "curImg",
         immediateRender: true,
         ease: Linear.easeNone,
         onUpdate: function () {
            document.getElementById("sec_chargetreeair_mobile").src = independentCharging_mobileSec[objindependentCharging_mobile.curImg];
         }
     });
     const indicatorOptions_independentCharging_mobile_sec = { name: "independentCharging_mobile_img" };
     setAnimation(sceneOptions_independentCharging_mobile_sec, tween_independentCharging_mobile_sec, controller, indicatorOptions_independentCharging_mobile_sec);

    // Rugged protection circle
    const SceneOptions_protectionCircle_mobile = {triggerElement: "#div_down_circle_mobile", duration: "50%", triggerHook: 1, reverse: true,};
    const protectionCircle_mobile_tween = TweenMax.fromTo("#div_down_circle_mobile", 1, { borderRadius: "0, 0, 0, 0"}, { borderRadius: "0, 0, 60%, 60%", ease: Linear.easeNone });
    const protectionCircle_mobile_indicator = { name: "protection_circle" };
    setAnimation(SceneOptions_protectionCircle_mobile, protectionCircle_mobile_tween, controller, protectionCircle_mobile_indicator);
}// JavaScript Document